import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import InputField from "../inputField/InputField";
import Strings from "../../res/String";
import addIcon from "../../assets/img/addIcon.svg";
import deleteIcon from "../../assets/img/delete.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import imageCompression from "browser-image-compression";
import PopUpModal from "../popupmodal/PopUpModal";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import logo from "../../assets/img/timber_logo.png";
import downloadfile from "../../assets/img/downloadfile.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import html2pdf from "html2pdf.js";

import { Button, IconButton } from "@mui/material";
import FileUploadSection from "./FileUploadSection";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import FileUploadContainer from "./FileUploadContainer";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import RightSideDrawer from "../Drawer/Drawer";
import { file } from "jszip";
import { useSelector } from "react-redux";
import { KeyboardReturnRounded } from "@mui/icons-material";
import ForwardcontractCopy from "../Forwardcontract/ForwardcontractCopy";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import StatusWaiverCopy from "../statusWaiver/StatusWaiverCopy";
import SBLCCopy from "../sblcComponent/SBLCCopy";
import FormA1Copy from "../../FormA1Component/FormA1Copy";

const tabs = [
  { id: "bl", label: "BL DETAILS" },
  { id: "inv", label: "INV DETAILS" },
  { id: "bank", label: "BANK" },
  { id: "be", label: "BE DETAILS" },
  { id: "ship", label: "SHIP & CH" },
  { id: "summary", label: "SUMMARY" },
  { id: "doc", label: "ADD DOC" },
];

const NewDataForm = (props) => {
  const { state } = useLocation();

  const copydocs = useSelector((state) => state?.copydoc);

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") || "bl";
  });

  // API Start
  const navigate = useNavigate();

  const [base64Xlsx, setBase64Xlsx] = useState("");
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fileName: "",
      exporter: "",
      dataEntryForm: [
        {
          containerNo: "",
          averageLength: "",
          avgCftAvgGirth: "",
          pcs: "",
          plCbm: "",
          grossCbm: "",
          netCbm: "",
          avgRate: "",
          amt: "",
          lorry: "",
          sellRate: "",
          sellCbm: "",
          brijeshComm: "",
          agent: "",
          pkl: "",
          containerImage: [],
        },
      ],
      dateOfShipping: "",
      etaDate: "",
      invoicedt: "",
      bgDate: "",
      dueDate: "",
      bankDeductionDate: "",
      forwardContractDate: "",
      beDate: "",
      dutyPaymentDate: "",
    },
  });

  const { append, remove, fields } = useFieldArray({
    name: "dataEntryForm",
    control,
  });
  const [imageName, setImageName] = useState({});
  const excelInputRef = useRef(null);
  const fileInputRef = useRef(null);

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const [isPopupOpen, setPopupOpen] = useState(false);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  // const dataEntryForm = watch("dataEntryForm", []);
  const {
    pqRelaxcheck,
    pqWeightcheck,
    billno,
    exporter,
    address,
    invoiceno,
    invoicedt,
    invoiceQuantity,
    invoiceRate,
    sblcInterestCharges,
    sblcInterestUsdRate,
    bgAmtInterestAmt,
    bgNumber,
    bgDate,
    foreignBankName,
    bgCharges,
    upFrontCharges,
    advice,
    margin10,
    margin5,
    adviceGst,
    M1AccountNumber,
    M2AccountNumber,
    beNo,
    beDate,
    beUsd,
    customDuty,
    socialWelfareCharges,
    beIgst,
    assessValue,
    shippingBill,
    pqFumigation,
    pqWeight,
    fumigationCharge,
    containersNumber,
    chaSurveyNew,
    cfsChargesNew,
    dueDate,
    bankDeductionDate,
    commodify,
    exchangeRate,
    dateOfShipping,
    forwardContractDate,
    etaDate,
    fileName,
    forwardcontractamount,
    cfsCharges,
    chaSurvey,
    cfsGroundRent,
    examinationChargenew,
    cfsGroundRentNew,
    freightChargeNew,
    unloadingNew,
    sec49New,
    yardRentNew,
    examinationCharge,
    freightCharge,
    unLoading,
    extraExpenses,
    sec49,
    totalCft,
    totalInt,
    od,
    agents,
    yardRent,
    cfsName,
    totalIndirectExpenses,
    dutyPaymentDate,
    cost,
    totalPcs,
    totalGrossCbm,
    totalNetCbm,
    totalAvgRate,
    totalAmount,
    roundOff,
    totalInvoiceAmt,
    brijesh,
    totalPlCbm,
    dataEntryForm,
    rolloverType,
  } = watch();

  let statuswaiver = {
    fileName: fileName || null,
    bgAmtInterestAmt: bgAmtInterestAmt || null,
    exporter: exporter || null,
    address: address || null,
    invoiceno: invoiceno || null,
    invoicedt: invoicedt || null,
    foreignBankName: foreignBankName || null,
    billno: billno || null,
  };

  // <<<<<START
  useEffect(() => {
    // BG-CHARGES
    const bggst = (Number(bgCharges) * 18) / 100;
    const bgInvs = Number(bgCharges) + Number(bggst);
    const bgval = Number(
      (bgInvs * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // UPFRONTCHARGES
    const frongst = (Number(upFrontCharges) * 18) / 100;
    const fronInvs = Number(upFrontCharges) + Number(frongst);
    const fronval = Number(
      (fronInvs * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // ADVICE
    const advisinst = Number(advice) + Number(adviceGst);
    const advisval = Number(
      (advisinst * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // MARGIN 10
    const marginval = Number(
      (margin10 * 2.5) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // MARGIN 5
    const marginvalfive = Number(
      (margin5 * 2.5) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // customDuty
    const customDutyval = Number(
      (customDuty * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // socialWelfareCharge
    const socialWelfareChargeval = Number(
      (Number(socialWelfareCharges) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // shippingBill
    const shippingBillgst = (Number(shippingBill) * 18) / 100;

    const shippingBillInvs = Number(shippingBill) + Number(shippingBillgst);

    const shippingBillval = Number(
      (shippingBillInvs * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // PQ WEIGHT
    const pqWeightInvs = (Number(pqWeightcheck) - 1) * 200 + 3500;
    const pqWeightval = Number(
      (pqWeightInvs * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // PQ FUMIGATION
    // const pqFumigationInvs = pqFumigation * 1;
    const pqFumigationInvs = pqFumigation * 0;
    const pqFumigationVal = Number(
      (pqFumigationInvs * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    //FUMIGATION CHARGES
    const fumigationChargeGst = (Number(fumigationCharge) * 18) / 100;
    const fumigationChargeInvs =
      Number(fumigationCharge) + Number(fumigationChargeGst);
    const fumigationChargeVal =
      fumigationChargeInvs == NaN
        ? 0
        : Number(
            (Number(fumigationChargeInvs) * 6) /
              100 /
              Number(totalNetCbm) /
              35.315
          ).toFixed(2);

    // CFS CHARGES
    const cfscharge = cfsChargesNew * Number(containersNumber);
    setValue("cfsCharges", (cfscharge && cfscharge) || undefined);
    const cfsGst = (Number(cfsCharges) * 18) / 100;
    const cfsChargesInvs = Number(cfsCharges) + Number(cfsGst);

    const cfsChargesVal = Number(
      (Number(cfsChargesInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // CHA SURVEY
    const chasurvey = chaSurveyNew * Number(containersNumber);
    setValue("chaSurvey", (chasurvey && chasurvey) || undefined);
    const chaGst = (Number(chaSurvey) * 18) / 100;
    const chaSurveyInvs = Number(chaSurvey) + Number(chaGst);
    const chaSurveyVal = Number(
      (Number(chaSurveyInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    //ExaminationCharges
    const examinationChargenews =
      examinationChargenew * Number(containersNumber);

    setValue(
      "examinationCharge",
      (examinationChargenews && examinationChargenews) || undefined
    );

    const cfsGroundRentNews = cfsGroundRentNew * Number(containersNumber);
    setValue(
      "cfsGroundRent",
      (cfsGroundRentNews && cfsGroundRentNews) || undefined
    );

    // FREIGHTCHARGES
    const freightcharge = freightChargeNew * Number(containersNumber);
    setValue("freightCharge", (freightcharge && freightcharge) || undefined);
    const freightChargeGst = (Number(freightCharge) * 5) / 100;

    const freightChargeInvs = Number(freightCharge) + Number(freightChargeGst);
    const freightChargeVal = Number(
      (Number(freightChargeInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    //UNLOADING
    const unloading = unloadingNew * Number(containersNumber);
    setValue("unLoading", (unloading && unloading) || undefined);
    const unLoadingGst = (Number(unLoading) * 18) / 100;

    const unLoadingInv = Number(unLoading) + Number(unLoadingGst);
    const unLoadingVal = Number(
      (Number(unLoadingInv) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // EXTRAEXPENSES
    const yardRentNews = yardRentNew * Number(containersNumber);
    // setValue("unLoading", (unloading && unloading) || undefined);

    setValue("extraExpenses", yardRentNews);
    //  sec49New
    const sec49News = sec49New * Number(containersNumber);
    // setValue("unLoading", (unloading && unloading) || undefined);

    setValue("sec49", sec49News);

    const extraExpensesGst = (Number(extraExpenses) * 18) / 100;
    // console.log("extraExpensesGst", extraExpensesGst);

    const extraExpensesInvs = Number(extraExpenses) + extraExpensesGst;
    // console.log("extraExpensesInvs", extraExpensesInvs);
    const extraExpensesVal = Number(
      (Number(extraExpensesInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // console.log("extraExpensesVal", extraExpensesVal);
    // TOTAL INT

    // PQweight*4
    const pqweightss =
      (Number(pqWeight) * 6) / 100 / Number(totalNetCbm) / 35.315;
    const pqfumigationss =
      (Number(pqFumigation) * 6) / 100 / Number(totalNetCbm) / 35.315;

    // Examination charges

    const examinationGst = (Number(examinationCharge) * 18) / 100;
    const examinationChargesInvs =
      Number(examinationCharge) + Number(examinationGst);
    const examinationChargesVal = Number(
      (Number(examinationChargesInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // CFS DROUND RENT
    const cfsGroundGst = (Number(cfsGroundRent) * 18) / 100;
    const cfsGroundChargesInvs = Number(cfsGroundRent) + Number(cfsGroundGst);
    const cfsGroundChargesVal = Number(
      (Number(cfsGroundChargesInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // sec49 CHARGES
    const sec49Gst = (Number(sec49) * 18) / 100;
    const sec49ChargesInvs = Number(sec49) + Number(sec49Gst);
    const sec49ChargesVal = Number(
      (Number(sec49ChargesInvs) * 6) / 100 / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    const totalintval = [
      bgval,
      fronval,
      advisval,
      marginval,
      marginvalfive,
      customDutyval,
      socialWelfareChargeval,
      shippingBillval,
      pqWeightval,
      pqFumigationVal,
      fumigationChargeVal,
      cfsChargesVal,
      chaSurveyVal,
      freightChargeVal,
      unLoadingVal,
      extraExpensesVal,
      pqfumigationss,
      pqweightss,
      examinationChargesVal,
      cfsGroundChargesVal,
      sec49ChargesVal,
    ]
      .reduce((sum, val) => sum + (Number(val) || 0), 0)
      .toFixed(2);

    // let totalintvals = totalintval;

    // if (totalintval !== NaN) {
    //   setValue("totalInt", (totalintvals && totalintvals) || undefined);
    // }
    let totalintvals = Number(totalintval); // Ensure it's a number

    if (!isNaN(totalintvals) && Number.isFinite(totalintvals)) {
      setValue("totalInt", totalintvals && totalintvals);
    } else {
      setValue("totalInt", 0);
    }

    // SBLC INTEREST AND CHARGES
    const sblcInterestChargesVal = Number(
      (Number(sblcInterestCharges) * Number(sblcInterestUsdRate)) /
        Number(totalNetCbm) /
        35.315
    ).toFixed(2);

    // BGCHARGES CFT
    const bgChargesCft = Number(
      Number(bgCharges) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // UPFRONTCHARGES CFT
    const upFrontChargesCft = Number(
      Number(upFrontCharges) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // ADVICECFT
    const adviceCft = Number(advice) / Number(totalNetCbm) / 35.315;
    // CUSTOMDUTYCFT
    const customDutyCft = Number(
      Number(customDuty) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // SOCIALWELFARECHARGECFT
    const socialWelfareChargeCft = Number(
      Number(socialWelfareCharges) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // SHIPPINGBILLCFT
    const shippingBillCft = Number(
      Number(shippingBill) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // PQWEIGHTCFT
    const pqWeightCft = Number(
      Number(pqWeightInvs) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // PQFUMIGATION CFT (PQ RELAX)

    // const pqFumigationInvsNew = Number(pqFumigation) * 1;
    const pqFumigationCft = Number(
      Number(pqFumigation) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // FUMIGATIONCHARGES
    const fumigationChargesCft =
      fumigationChargeInvs == NaN
        ? 0
        : Number(
            Number(fumigationChargeInvs) / Number(totalNetCbm) / 35.315
          ).toFixed(2);

    // CFSCHARGESCFT
    const cfsChargesCft = Number(
      Number(cfsCharges) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // CHA SURVEY
    const chaSurveyCft = Number(
      Number(chaSurvey) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // FREIGHTCHARGECFT
    const freightChargeCft = Number(
      Number(freightCharge) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // UNLOADINGCFT
    const unLoadingCft = Number(
      Number(unLoading) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // EXTRAEXPENSES CFT
    const extraExpensesCft = Number(
      Number(extraExpenses) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // Examination
    const examinationChargeCft = Number(
      Number(examinationCharge) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // CFS Grund charge
    const cfsGroundChargeCft = Number(
      Number(cfsGroundRent) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // Sec49
    const sec49ChargeCft = Number(
      Number(sec49) / Number(totalNetCbm) / 35.315
    ).toFixed(2);

    // PQweight*4 CFT
    const pqweight4timesInv = Number(pqWeightInvs) * Number(pqWeight);

    const pqweight4timesCft = Number(pqWeight) / Number(totalNetCbm) / 35.315;

    const pqweights = Number(pqWeight) / Number(totalNetCbm) / 35.315;
    const pqfumigations = Number(
      Number(pqFumigation) / Number(totalNetCbm) / 35.315
    ).toFixed(2);
    // console.log("fumigationChargesCft", fumigationChargesCft);
    const totalCftVal = [
      sblcInterestChargesVal,
      bgChargesCft,
      upFrontChargesCft,
      adviceCft,
      customDutyCft,
      socialWelfareChargeCft,
      shippingBillCft,
      pqWeightCft,
      pqFumigationCft,
      fumigationChargesCft,
      cfsChargesCft,
      chaSurveyCft,
      freightChargeCft,
      unLoadingCft,
      extraExpensesCft,
      examinationChargeCft,
      sec49ChargeCft,
      cfsGroundChargeCft,
      pqweight4timesCft,
    ]
      .reduce((sum, val) => sum + (Number(val) || 0), 0)
      .toFixed(2);

    // let a = totalCftVal;

    // if (a !== NaN) {
    //   setValue("totalCft", a || undefined);
    // }

    let a = Number(totalCftVal);

    if (!isNaN(a) && Number.isFinite(a)) {
      setValue("totalCft", a);
    } else {
      setValue("totalCft", 0);
    }

    // OD
    setValue("od", (totalInt && totalInt) || undefined);
    // AGENTS
    setValue("agents", 30);
    // YARD RENT
    const yardRentVal =
      (Number(containersNumber) * 3000) / Number(totalNetCbm) / 35.315;
    let yardRents = yardRentVal.toFixed(2);
    setValue("yardRent", (yardRents && yardRents) || undefined);
    // let totalIndirectExpensess = Number(totalInt) + 30 + Number(yardRentVal);
    // setValue("totalIndirectExpenses", totalIndirectExpensess.toFixed(2));

    // COST
    const costVal =
      Number(totalCft) + Number(od) + Number(agents) + Number(yardRent);
    setValue("cost", (costVal && costVal) || undefined);
  }, [
    cfsChargesNew,
    chaSurveyNew,
    unloadingNew,
    sec49New,
    sblcInterestCharges,
    yardRentNew,
    sblcInterestUsdRate,
    totalInt,
    extraExpenses,
    unLoading,
    freightCharge,
    chaSurvey,
    containersNumber,
    cfsCharges,
    fumigationCharge,
    pqFumigation,
    pqWeight,
    pqWeightcheck,
    shippingBill,
    socialWelfareCharges,
    customDuty,
    bgCharges,
    margin5,
    margin10,
    // invoiceQuantity,
    upFrontCharges,
    adviceGst,
    advice,
    totalCft,
    cost,
    od,
    yardRent,
    agents,
    // examinationChargenew,
    examinationChargenew,
    cfsGroundRentNew,
    freightChargeNew,
    sec49,
    cfsGroundRent,
    examinationCharge,
    totalNetCbm,
  ]);

  const [fileList, setFileList] = useState([]); // Flat array of File objects
  const [base64String, setBase64String] = useState([]);

  const [drawerState, setDrawerState] = React.useState({});

  const pdfToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  //API START
  const { mutate: createInvoice, isLoading: isCreating } = useMutation(
    (postData) =>
      axios.post(`${process.env.REACT_APP_HOST}/invoices`, postData, {
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        headers: { "Content-Type": "application/json" },
      }),
    {
      onSuccess: (response) => {
        console.log("✅ Invoice created successfully:", response);

        setPopupOpen(1);
      },
      onError: (error) => {
        console.error(" Failed to create invoice:", error);
        alert("Error while creating invoice. Please try again.");
      },
    }
  );
  // UPDATE API
  const { mutate: updateInvoice, isLoading: isUpdating } = useMutation(
    (postData) =>
      axios.put(
        `${process.env.REACT_APP_HOST}/invoices/${state?.id}`,
        postData,
        {
          headers: { "Content-Type": "application/json" },
        }
      ),
    {
      onSuccess: (response) => {
        console.log("✅ Invoice updated successfully:", response);
        setPopupOpen(!isPopupOpen);
      },
      onError: (error) => {
        console.error("Failed to update invoice:", error);
        alert("Error while updating invoice. Please check and try again.");
      },
    }
  );

  // Create File Upload Hook
  const useCreateFileUpload = () =>
    useMutation(
      (data) =>
        axios.post(`${process.env.REACT_APP_HOST}/copydocuments/create`, data, {
          headers: { "Content-Type": "application/json" },
        }),
      {
        onSuccess: (response) => {
          console.log("✅ File created successfully:", response);
        },
        onError: (error) => {
          console.error("Failed to upload file:", error);
          alert("Error while uploading file. Please try again.");
        },
      }
    );

  // Update File Upload Hook
  const useUpdateFileUpload = (blNo) =>
    useMutation(
      (data) =>
        axios.put(`${process.env.REACT_APP_HOST}/copydocuments/${blNo}`, data, {
          headers: { "Content-Type": "application/json" },
        }),
      {
        onSuccess: (response) => {
          console.log("✅ File updated successfully:", response);
        },
        onError: (error) => {
          alert("Error while updating file. Please try again.");
        },
      }
    );

  const createFileUpload = useCreateFileUpload();
  const updateFileUpload = useUpdateFileUpload(state?.blNo);

  const [isUploading, setIsUploading] = useState(false);

  /**********************************************************************
   * 2.  FETCH EXISTING COPIES  (only when state?.id exists = edit mode)
   *********************************************************************/
  const fetchCopyDoc = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_HOST}/copydocuments/${state?.blNo}`
    );
    return data;
  };

  const { data: copyDoc, isSuccess: isSuccessCopyDoc } = useQuery(
    ["fetchcopydoc", state?.blNo],
    fetchCopyDoc,
    { enabled: Boolean(state?.id) } // run only in edit mode
  );

  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (
      isFirstLoad.current &&
      isSuccessCopyDoc &&
      Array.isArray(copyDoc?.copyDocumentsList)
    ) {
      const existing = copyDoc?.copyDocumentsList?.map((doc, index) => ({
        fileName: doc?.fileName?.trim() || `File ${index + 1}`,
        base64: doc?.base64 || "",
        fromServer: true,
      }));

      setFileList(existing?.length > 0 ? existing : []); // optional fallback
      isFirstLoad.current = false; // ✅ only load once
    }
  }, [copyDoc, isSuccessCopyDoc]);

  // Fetch BL Data API

  // let { billno } = watch();
  // const mutation = useUserFileUploads(); // Initialize the mutation here

  /**********************************************************************
   * 3.  HELPER: File -> base64
   *********************************************************************/
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
    });

  /**********************************************************************
   * 4.  FILE PICKER HANDLER
   *********************************************************************/
  const handleFileChange = async (e) => {
    if (!billno) {
      alert("Kindly Add a Bill No");
      return;
    }

    const files = Array.from(e.target.files);
    if (!files.length) return;

    setIsUploading(true);
    try {
      const uploads = await Promise.all(
        files?.map(async (file) => ({
          fileName: file?.name,
          base64: await fileToBase64(file),
          fromServer: false,
        }))
      );
      setFileList((prev) => [...prev, ...uploads]); // append new uploads
    } catch (err) {
      console.error("Base64 conversion error", err);
    } finally {
      setIsUploading(false);
      e.target.value = null; // allow picking same file again
    }
  };

  /**********************************************************************
   * 5.  REMOVE FILE  (delete on server if it came from server)
   *********************************************************************/
  const removeFile = async (index) => {
    const target = fileList[index];

    // delete on server only if this came from the server
    if (target?.fromServer) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_HOST}/copydocuments/${billno}/copy/${index}`
        );
      } catch (err) {
        console.error("Server delete failed", err);
        alert("Could not delete on server, removing locally.");
      }
    }

    // always update local list (and UI)
    setFileList((prev) => prev.filter((_, i) => i !== index));
  };

  const toggleDrawer = (arrayName, open) => () => {
    setDrawerState((prev) => ({ ...prev, [arrayName]: open }));
  };

  const formData = new FormData();

  fileList &&
    fileList?.copydoc &&
    fileList?.copydoc.forEach((value) => {
      formData.append("copydocument[]", value);
    });

  const [files, setFiles] = useState(Array(10).fill(null));
  const [base64Files, setBase64Files] = useState(Array(10).fill(null));

  const handleFileChanges = (index, event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];

        setFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          newFiles[index] = file;
          return newFiles;
        });

        setBase64Files((prevBase64Files) => {
          const newBase64Files = [...prevBase64Files];
          newBase64Files[index] = base64String;
          return newBase64Files;
        });
      };

      reader.readAsDataURL(file);
    }

    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = file;
      return newFiles;
    });
  };

  const handleFileRemove = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = null;
      return newFiles;
    });
    setBase64Files((prevBase64Files) => {
      const newBase64Files = [...prevBase64Files];
      newBase64Files[index] = null;
      return newBase64Files;
    });
  };

  // calculation For userForm
  const updateTotals = () => {
    const totalPcs = dataEntryForm?.reduce((total, item) => {
      const pcs = parseFloat(item?.pcs);
      return total + (!isNaN(pcs) ? pcs : 0);
    }, 0);
    const totalPlCbm = dataEntryForm?.reduce((total, item) => {
      const plcbm = parseFloat(item?.plCbm);
      return total + (!isNaN(plcbm) ? plcbm : 0);
    }, 0);
    const totalsellCbm = dataEntryForm?.reduce((total, item) => {
      const sellCbm = parseFloat(item?.sellCbm);
      return total + (!isNaN(sellCbm) ? sellCbm : 0);
    }, 0);
    dataEntryForm &&
      dataEntryForm?.forEach((item, index) => {
        let netCbm = item?.netCbm;
        let avgRate = item?.avgRate;
        if (netCbm && avgRate) {
          const amt = Number(netCbm) * Number(avgRate);
          setValue(`dataEntryForm.${index}.amt`, Number(amt) || 0); // Set calculated amt
        }
      });
    const totalAmt = dataEntryForm?.reduce((total, item) => {
      const amt = parseFloat(item?.amt);
      return total + (!isNaN(amt) ? amt : 0);
    }, 0);
    const totalgrossCbm = dataEntryForm?.reduce((total, item) => {
      const grossCbm = parseFloat(item?.grossCbm);
      return total + (!isNaN(grossCbm) ? grossCbm : 0);
    }, 0);
    const totalnetCbm = dataEntryForm?.reduce((total, item) => {
      const netCbm = parseFloat(item?.netCbm);
      return total + (!isNaN(netCbm) ? netCbm : 0);
    }, 0);
    const totalbrijesh = dataEntryForm?.reduce((total, item) => {
      const brijeshcomm = Number(item?.brijeshComm) * Number(item?.netCbm);
      return total + (!isNaN(brijeshcomm) ? brijeshcomm : 0);
    }, 0);

    setValue("brijesh", Number(totalbrijesh).toFixed(2));

    setValue("totalNetCbm", Number(totalnetCbm).toFixed(2));
    setValue("totalsellCbm", Number(totalsellCbm).toFixed(2));
    setValue("totalGrossCbm", Number(totalgrossCbm));
    setValue("totalPcs", totalPcs);
    setValue("totalPlCbm", totalPlCbm);
    setValue("totalAmount", Number(totalAmt));
    let totalavgrateval = Number(totalAmt) / Number(totalnetCbm);
    setValue(
      "totalAvgRate",
      (totalavgrateval && totalavgrateval).toFixed(2) || undefined
    );
    let totalinvoice = Number(totalAmt) - Number(roundOff);
    setValue("totalInvoiceAmt", totalinvoice);
  };
  useEffect(() => {
    updateTotals();
  }, [dataEntryForm, roundOff]);

  const [drawerOpenIndex, setDrawerOpenIndex] = useState(null);

  // Open or close the drawer
  const toggleDrawers = (index) => () => {
    setDrawerOpenIndex((prev) => (prev === index ? null : index));
  };

  // containerImage
  // State to store Base64 strings and file names
  const [fileBase64, setFileBase64] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [fileNamesImg, setFileNamesImg] = useState([]);
  const [containerfileNamesImg, setContainerFileNamesImg] = useState([
    {
      fileName: [],
      base64Files: [],
    },
  ]);
  const [fileUploading, setFileUploading] = useState([
    {
      summaryDoc: {
        name: "",
        file: "",
      },
    },
  ]);
  const imageRefs = useRef([]);
  // Handle file input changes
  const handleImageChange = async (index, event) => {
    const files = Array.from(event.target.files);

    try {
      // Compress the images before converting to Base64
      const base64Strings = await compressAndConvertFiles(files);

      setContainerFileNamesImg((prev) => {
        const updatedFileNames = [...prev];
        updatedFileNames[index] = {
          ...updatedFileNames[index],
          fileName: files.map((file) => file.name),
          base64Files: base64Strings,
        };

        return updatedFileNames; // Return the updated state
      });
      // updateLocalState(index, files, base64Strings);
      setValue(dataEntryForm[`${index}`].containerImage, files);
    } catch (error) {
      console.error("Error compressing or processing files:", error);
    }
  };

  // Compress and convert files to Base64 strings
  const compressAndConvertFiles = async (files) => {
    const base64Strings = await Promise.all(
      files.map((file) => compressImage(file))
    );
    return base64Strings;
  };

  // Compress a single image using browser-image-compression
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const options = {
        maxSizeMB: 0.15, // Set maximum file size to 150 KB
        maxWidthOrHeight: 800, // Set maximum width or height (optional)
        useWebWorker: true,
      };

      imageCompression(file, options)
        .then((compressedFile) => {
          // Convert the compressed image file to Base64
          fileToBase64String(compressedFile)
            .then((base64String) => resolve(base64String.split(",")[1])) // Return only the Base64 part
            .catch((error) =>
              reject("Error converting file to Base64: " + error)
            );
        })
        .catch((error) => reject("Error compressing image: " + error));
    });
  };

  // Convert file to Base64
  const fileToBase64String = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file); // Read file as data URL (Base64)
    });
  };

  // Update local state for Base64 strings and file names

  const updateLocalState = (index, files, base64Strings) => {
    setFileBase64((prevState) => {
      const updatedFileBase64 = [...prevState];
      updatedFileBase64[index] = base64Strings;
      return updatedFileBase64;
    });

    setFileNames((prevState) => {
      const updatedFileNames = [...prevState];
      updatedFileNames[index] = files.map((file) => file.name);
      return updatedFileNames;
    });
    setFileNamesImg((prevState) => {
      const updatedFileNames = [...prevState];
      updatedFileNames[index] = files.map((file) => file);
      return updatedFileNames;
    });
  };

  // Remove a specific file from the list
  const [isactive, setIsActive] = useState([]);
  const handleRemoveFile = (formIndex, fileIndex) => {
    setContainerFileNamesImg((prev) => {
      const updatedFileBase64 = [...prev];
      updatedFileBase64[formIndex] = {
        ...updatedFileBase64[formIndex],
        fileName: updatedFileBase64[formIndex].fileName.filter(
          (_, i) => i !== fileIndex
        ),
        base64Files: updatedFileBase64[formIndex].base64Files.filter(
          (_, i) => i !== fileIndex
        ),
      };
      return updatedFileBase64;
    });
  };
  useEffect(() => {
    if (isactive.length > 0) {
      handleRemoveFile(...isactive);
      setIsActive([]);
    }
  }, [isactive]);

  const [pdfBase64, setPdfBase64] = useState("");
  const [statusBase64, setStatusBase64] = useState("");
  const [formBase64, setFormBase64] = useState("");
  const [sblcBase64, setSblcBase64] = useState("");
  const printRef = useRef();
  const statusRef = useRef();
  const formRef = useRef();
  const sblcRef = useRef();

  // GENERATE PDF WHILE SUBMITTING THE FORM
  const generatePDF = async () => {
    const element = printRef.current;
    if (!element) {
      console.error("PDF content not found");
      return null;
    }

    const opt = {
      margin: [1, 1, 1, 1],
      filename: "Forward Contract.pdf",
      image: { type: "jpeg", quality: 0.5 },
      html2canvas: { scale: 1.2, useCORS: true }, // Reduced scale to reduce resolution
      jsPDF: { unit: "mm", format: [210, 435], orientation: "portrait" }, // A4 format (you had 435mm, which is very large)
      pagebreak: { mode: ["avoid-all", "css"] },
    };

    try {
      const pdf = await html2pdf().set(opt).from(element).toPdf().get("pdf");

      // Compress PDF further (attempting to reduce size here)
      const pdfBlob = pdf.output("blob");

      // Convert Blob to Base64
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];

          // Check if the PDF size is under the target size (150KB)
          if (base64String.length > 150 * 1024) {
            console.warn("The PDF is still larger than the target size.");
          }

          setPdfBase64(base64String);
          resolve(base64String);
        };
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };

  const generateStatusPDF = async () => {
    const element = statusRef.current;
    if (!element) {
      console.error("PDF content not found");
      return null;
    }

    const opt = {
      margin: [1, 1, 1, 1],
      filename: "Status Waiver.pdf",
      image: { type: "jpeg", quality: 0.5 },
      html2canvas: { scale: 1.2, useCORS: true }, // Reduced scale to reduce resolution
      jsPDF: { unit: "mm", format: [210, 435], orientation: "portrait" }, // A4 format (you had 435mm, which is very large)
      pagebreak: { mode: ["avoid-all", "css"] },
    };

    try {
      const pdf = await html2pdf().set(opt).from(element).toPdf().get("pdf");

      // Compress PDF further (attempting to reduce size here)
      const pdfBlob = pdf.output("blob");

      // Convert Blob to Base64
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];

          // Check if the PDF size is under the target size (150KB)
          if (base64String.length > 150 * 1024) {
            console.warn("The PDF is still larger than the target size.");
          }

          setStatusBase64(base64String);
          resolve(base64String);
        };
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };
  const generateFormPDF = async () => {
    const element = formRef.current;
    if (!element) {
      console.error("PDF content not found");
      return null;
    }

    const opt = {
      margin: [1, 1, 1, 1],
      filename: "Form A1.pdf",
      image: { type: "jpeg", quality: 0.5 },
      html2canvas: { scale: 1.2, useCORS: true }, // Reduced scale to reduce resolution
      jsPDF: { unit: "mm", format: [210, 435], orientation: "portrait" }, // A4 format (you had 435mm, which is very large)
      pagebreak: { mode: ["avoid-all", "css"] },
    };

    try {
      const pdf = await html2pdf().set(opt).from(element).toPdf().get("pdf");

      // Compress PDF further (attempting to reduce size here)
      const pdfBlob = pdf.output("blob");

      // Convert Blob to Base64
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];

          // Check if the PDF size is under the target size (150KB)
          if (base64String.length > 150 * 1024) {
            console.warn("The PDF is still larger than the target size.");
          }

          setFormBase64(base64String);
          resolve(base64String);
        };
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };

  const generateSblcPDF = async () => {
    const element = sblcRef.current;
    if (!element) {
      console.error("PDF content not found");
      return null;
    }

    const opt = {
      margin: [1, 1, 1, 1],
      filename: "SBLC.pdf",
      image: { type: "jpeg", quality: 0.5 },
      html2canvas: { scale: 1.2, useCORS: true },
      jsPDF: { unit: "mm", format: [210, 435], orientation: "portrait" }, // A4 format (you had 435mm, which is very large)
      pagebreak: { mode: ["avoid-all", "css"] },
    };

    try {
      const pdf = await html2pdf().set(opt).from(element).toPdf().get("pdf");

      // Compress PDF further (attempting to reduce size here)
      const pdfBlob = pdf.output("blob");

      // Convert Blob to Base64
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];

          // Check if the PDF size is under the target size (150KB)
          if (base64String.length > 150 * 1024) {
            console.warn("The PDF is still larger than the target size.");
          }

          setSblcBase64(base64String);
          resolve(base64String);
        };
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };
  // END

  // FORM SUBMISSION
  const onSubmit = async (data) => {
    const base64Pdf = await generatePDF();
    const statusbase64Pdf = await generateStatusPDF();
    const formbase64Pdf = await generateFormPDF();
    const sblcbase64Pdf = await generateSblcPDF();
    let formPayload = {
      pqRelaxcheck: data && data?.pqRelaxcheck,
      pqWeightcheck: data && data?.pqWeightcheck,
      blNo: data && data?.billno ? data && data?.billno : "",
      exporter: data && data?.exporter ? data && data?.exporter : "",
      address: data && data?.address ? data && data?.address : "",
      invoiceNo: data && data?.invoiceno ? data && data?.invoiceno : "",
      invoiceDt:
        (data && data?.invoicedt == "Invalid date") ||
        (data && data?.invoicedt == "")
          ? null
          : data && data?.invoicedt,
      invoiceQuantity:
        data && data?.invoiceQuantity
          ? Number(data && data?.invoiceQuantity)
          : 0,
      invoiceRate:
        data && data?.invoiceRate ? Number(data && data?.invoiceRate) : 0,
      sblcInterestAndCharges:
        data && data?.sblcInterestCharges
          ? Number(data && data?.sblcInterestCharges)
          : 0,
      sblcInterestUsdRate:
        data && data?.sblcInterestUsdRate
          ? Number(data && data?.sblcInterestUsdRate)
          : 0,
      bgAmtAndInterestAmt:
        data && data?.bgAmtInterestAmt
          ? Number(data && data?.bgAmtInterestAmt)
          : 0,
      bgNumber: data && data?.bgNumber ? data && data?.bgNumber : "",
      bgdate:
        (data && data?.bgDate == "Invalid date") || (data && data?.bgDate == "")
          ? null
          : data && data?.bgDate,
      foreignBankName:
        data && data?.foreignBankName ? data && data?.foreignBankName : "",
      bgCharges: data && data?.bgCharges ? Number(data && data?.bgCharges) : 0,
      upfrontCharges:
        data && data?.upFrontCharges ? Number(data && data?.upFrontCharges) : 0,
      advice: data && data?.advice ? data && data?.advice : "",
      margin10: data && data?.margin10 ? Number(data && data?.margin10) : 0,
      margin5: data && data?.margin5 ? Number(data && data?.margin5) : 0,
      adviceGst: data && data?.adviceGst,
      m1AccountNumber: data && data?.M1AccountNumber,
      m2AccountNumber: data && data?.M2AccountNumber,
      beNo: data && data?.beNo,
      beDate:
        (data && data?.beDate == "Invalid date") || (data && data?.beDate == "")
          ? null
          : data && data?.beDate,
      beUsed: data && data?.beUsd ? Number(data && data?.beUsd) : 0,
      customsDuty:
        data && data?.customDuty ? Number(data && data?.customDuty) : 0,
      socialWelfareCharges:
        data && data?.socialWelfareCharges
          ? Number(data && data?.socialWelfareCharges)
          : 0,
      beIgst: data && data?.beIgst ? Number(data && data?.beIgst) : 0,
      assessValue:
        data && data?.assessValue ? Number(data && data?.assessValue) : 0,
      shippingBill:
        data && data?.shippingBill ? Number(data && data?.shippingBill) : 0,
      pqWeight: data && data?.pqWeight,
      pqFumigation:
        data && data?.pqFumigation ? Number(data && data?.pqFumigation) : 0,
      fumigationCharges: data && data?.fumigationCharge,
      containersNumber: data && data?.containersNumber,
      chaSurveyNew: data && data?.chaSurveyNew,
      cfsChargesNew: data && data?.cfsChargesNew,
      dueDate:
        (data && data?.dueDate == "Invalid date") ||
        (data && data?.dueDate == "")
          ? null
          : data && data?.dueDate,
      bankDeductionDate:
        (data && data?.bankDeductionDate == "Invalid date") ||
        (data && data?.bankDeductionDate == "")
          ? null
          : data && data?.bankDeductionDate,
      commodify: data && data?.commodify,
      exchangeRate:
        data && data?.exchangeRate ? Number(data && data?.exchangeRate) : 0,
      dateOfShipping:
        (data && data?.dateOfShipping == "Invalid date") ||
        data?.dateOfShipping == ""
          ? null
          : data && data?.dateOfShipping,

      forwardContractDate:
        (data && data?.forwardContractDate == "Invalid date") ||
        (data && data?.forwardContractDate == "")
          ? null
          : data && data?.forwardContractDate,
      etaDate:
        (data && data?.etaDate == "Invalid date") ||
        (data && data?.etaDate == "")
          ? null
          : data && data?.etaDate,
      fileName: data && data?.fileName,
      contractAmount: data && data?.forwardcontractamount,
      cfsCharges:
        data && data?.cfsCharges ? Number(data && data?.cfsCharges) : 0,
      chaSurvey: data && data?.chaSurvey ? Number(data && data?.chaSurvey) : 0,
      cfsGroundRent: data && data?.cfsGroundRent,
      examinationChargenew: data && data?.examinationChargenew,
      cfsGroundRentNew: data && data?.cfsGroundRentNew,
      freightChargeNew: data && data?.freightChargeNew,
      unloadingNew: data && data?.unloadingNew,
      sec49New: data && data?.sec49New,
      yardRentNew: data && data?.yardRentNew,
      examinationCharge: data && data?.examinationCharge,
      freightCharge:
        data && data?.freightCharge ? Number(data && data?.freightCharge) : 0,
      unloading: data && data?.unLoading,
      extraExpenses:
        data && data?.extraExpenses ? data && data?.extraExpenses : "",
      sec49: data && data?.sec49 ? data && data?.sec49 : "",
      totalCft: data && data?.totalCft !== "NaN" ? data && data?.totalCft : "",
      totalInt: data && data?.totalInt !== "NaN" ? data && data?.totalInt : "",
      od: data && data?.od !== "NaN" ? data && data?.od : "",
      agents: data && data?.agents,
      yardRent:
        data &&
        data?.yardRent !== "NaN" &&
        data &&
        data?.yardRent !== "Infinity"
          ? data && data?.yardRent
          : "",
      cfsName: data && data?.cfsName,
      // totalIndirectExpenses:
      //   data && data?.totalIndirectExpenses !== "NaN"
      //     ? data && data?.totalIndirectExpenses
      //     : "",
      dutyPaymentDate:
        (data && data?.dutyPaymentDate == "Invalid date") ||
        (data && data?.dutyPaymentDate == "")
          ? null
          : data && data?.dutyPaymentDate,
      cost: data && data?.cost,
      userForm:
        data &&
        data?.dataEntryForm.map((entry, index) => ({
          containerNo: entry.containerNo,
          averageLength: entry.averageLength,
          avgCftAvgGirth: entry.avgCftAvgGirth,
          pcs: entry.pcs,
          plCbm: entry.plCbm,
          grossCbm: entry.grossCbm,
          netCbm: entry.netCbm,
          avgRate: entry.avgRate,
          amt: entry.amt,
          lorry: entry.lorry,
          sellRate: entry.sellRate,
          sellCbm: entry.sellCbm,
          brijeshComm: entry.brijeshComm,
          agent: entry.agent,
          pkl: entry.pkl,
          status: entry?.status,
          containerImage: containerfileNamesImg[index]?.base64Files
            ? containerfileNamesImg[index]?.base64Files
            : [],
        })),
      totalPcs: data && data?.totalPcs,
      totalGrossCbm: data && data?.totalGrossCbm,
      totalNetCbm: data && data?.totalNetCbm,
      totalAvgRate:
        data && data?.totalAvgRate !== null
          ? Number(data && data?.totalAvgRate)
          : 0,
      totalAmount:
        data && data?.totalAmount ? Number(data && data?.totalAmount) : 0,
      roundOff: data && data?.roundOff ? Number(data && data?.roundOff) : 0,
      totalInvoiceAmount:
        data && data?.totalInvoiceAmt
          ? Number(data && data?.totalInvoiceAmt)
          : 0,
      bruesh: data && data?.brijesh ? Number(data && data?.brijesh) : 0,
      // ===== Rollover Same BG =====
      rolloverSameBgUpfrontCharges: data && data?.rolloverSameBgUpfrontCharges,
      rolloverSameBgForeignBankName:
        data && data?.rolloverSameBgForeignBankName,

      rolloverSameBgM3: data && data?.rolloverSameBgM3,
      rolloverSameBgM3Date: data && data?.rolloverSameBgM3Date,
      rolloverSameBgM3Value: data && data?.rolloverSameBgM3Value,
      rolloverSameBgM3Dom: data && data?.rolloverSameBgM3Dom,
      rolloverSameBgM3Mv: data && data?.rolloverSameBgM3Mv,

      rolloverSameBgBgNumber: data && data?.rolloverSameBgBgNumber,
      rolloverSameBgBgDate: data && data?.rolloverSameBgBgDate,
      rolloverSameBgBgCharges: data && data?.rolloverSameBgBgCharges,
      rolloverSameBgSblcInterestCharges:
        data && data?.rolloverSameBgSblcInterestCharges,
      rolloverSameBgDueDate: data && data?.rolloverSameBgDueDate,

      rolloverSameBgAdvice: data && data?.rolloverSameBgAdvice,
      rolloverSameBgAdviceGst: data && data?.rolloverSameBgAdviceGst,
      rolloverSameBgExchangeRate: data && data?.rolloverSameBgExchangeRate,
      rolloverSameBgBankDeductingDate:
        data && data?.rolloverSameBgBankDeductingDate,
      rolloverSameBgForwardCoverDate:
        data && data?.rolloverSameBgForwardCoverDate,
      rolloverSameBgForwardCoveredAmt:
        data && data?.rolloverSameBgForwardCoveredAmt,

      // ===== Rollover New BG =====
      rolloverNewBgUpfrontCharges: data && data?.rolloverNewBgUpfrontCharges,
      rolloverNewBgForeignBankName: data && data?.rolloverNewBgForeignBankName,

      rolloverNewBgM1: data && data?.rolloverNewBgM1,
      rolloverNewBgM1Date: data && data?.rolloverNewBgM1Date,
      rolloverNewBgM1Value: data && data?.rolloverNewBgM1Value,
      rolloverNewBgM1Dom: data && data?.rolloverNewBgM1Dom,
      rolloverNewBgM1Mv: data && data?.rolloverNewBgM1Mv,

      rolloverNewBgM2: data && data?.rolloverNewBgM2,
      rolloverNewBgM2Date: data && data?.rolloverNewBgM2Date,
      rolloverNewBgM2Value: data && data?.rolloverNewBgM2Value,
      rolloverNewBgM2Dom: data && data?.rolloverNewBgM2Dom,
      rolloverNewBgM2Mv: data && data?.rolloverNewBgM2Mv,

      rolloverNewBgBgNumber: data && data?.rolloverNewBgBgNumber,
      rolloverNewBgBgDate: data && data?.rolloverNewBgBgDate,
      rolloverNewBgBgCharges: data && data?.rolloverNewBgBgCharges,
      rolloverNewBgSblcInterestCharges:
        data && data?.rolloverNewBgSblcInterestCharges,
      rolloverNewBgDueDate: data && data?.rolloverNewBgDueDate,

      rolloverNewBgAdvice: data && data?.rolloverNewBgAdvice,
      rolloverNewBgAdviceGst: data && data?.rolloverNewBgAdviceGst,
      rolloverNewBgExchangeRate: data && data?.rolloverNewBgExchangeRate,
      rolloverNewBgBankDeductingDate:
        data && data?.rolloverNewBgBankDeductingDate,
      rolloverNewBgForwardCoverDate:
        data && data?.rolloverNewBgForwardCoverDate,
      rolloverNewBgForwardCoveredAmt:
        data && data?.rolloverNewBgForwardCoveredAmt,

      // ===== Bank Details =====
      bankDetailsM1Date: data && data?.bankDetailsM1Date,
      bankDetailsM1Value: data && data?.bankDetailsM1Value,
      bankDetailsM1Dom: data && data?.bankDetailsM1Dom,
      bankDetailsM1Mv: data && data?.bankDetailsM1Mv,
      bankDetailsM2Date: data && data?.bankDetailsM2Date,
      bankDetailsM2Value: data && data?.bankDetailsM2Value,
      bankDetailsM2Dom: data && data?.bankDetailsM2Dom,
      bankDetailsM2Mv: data && data?.bankDetailsM2Mv,
      rolloverdays: data && data?.rolloverdays,
      rolloverType: data && data?.rolloverType,

      quotedocument: base64Files[0],
      bldocument: base64Files[1],
      rollOverDocument: base64Files[2],
      forwardContractForm: base64Pdf ? base64Pdf : null,
      sblcEmailDocument: sblcbase64Pdf ? sblcbase64Pdf : null,
      formA1: formbase64Pdf ? formbase64Pdf : null,
      statusWaiver: statusbase64Pdf ? statusbase64Pdf : null,
    };

    const filePayload = {
      blNo: billno,
      copy: fileList?.length
        ? fileList?.map(({ fileName, base64 }) => ({ fileName, base64 }))
        : [{ fileName: null, base64: null }],
    };

    try {
      await Promise.all([
        state?.id
          ? updateFileUpload.mutateAsync(filePayload)
          : createFileUpload.mutateAsync(filePayload),
        state?.id ? updateInvoice(formPayload) : createInvoice(formPayload),
      ]);
    } catch (err) {
      console.error("Error during submission:", err);
    }
  };

  // SETVALEU FOR STATE
  useEffect(() => {
    if (state) {
      remove();
      setValue("pqRelaxcheck", state?.pqRelaxcheck);
      setValue("pqWeightcheck", state?.pqWeightcheck);
      setValue("billno", state?.blNo);
      setValue("exporter", state?.exporter);
      setValue("cfsChargesNew", state?.cfsChargesNew);
      setValue("chaSurveyNew", state?.chaSurveyNew);
      setValue("address", state?.address);
      setValue("invoiceno", state?.invoiceNo);
      setValue("invoicedt", moment(state?.invoiceDt).format("YYYY-MM-DD"));
      setValue("invoiceQuantity", state?.invoiceQuantity);
      setValue("invoiceRate", state?.invoiceRate);
      setValue("sblcInterestCharges", state?.sblcInterestAndCharges);
      setValue("sblcInterestUsdRate", state?.sblcInterestUsdRate);
      setValue("bgAmtInterestAmt", state?.bgAmtAndInterestAmt);
      setValue("bgNumber", state?.bgNumber);
      setValue("bgDate", moment(state?.bgdate).format("YYYY-MM-DD"));
      setValue("foreignBankName", state?.foreignBankName);
      setValue("bgCharges", state?.bgCharges);
      setValue("upFrontCharges", state?.upfrontCharges);
      setValue("advice", state?.advice);
      setValue("margin10", state?.margin10);
      setValue("adviceGst", state?.adviceGst);
      setValue("margin5", state?.margin5);
      setValue("M1AccountNumber", state?.m1AccountNumber);
      setValue("M2AccountNumber", state?.m2AccountNumber);
      setValue("beNo", state?.beNo);
      setValue("beDate", moment(state?.beDate).format("YYYY-MM-DD"));
      setValue("beUsd", state?.beUsed);
      setValue("customDuty", state?.customsDuty);
      setValue("socialWelfareCharges", state?.socialWelfareCharges);
      setValue("beIgst", state?.beIgst);
      setValue("assessValue", state?.assessValue);
      setValue("shippingBill", state?.shippingBill);
      setValue("pqWeight", state?.pqWeight);
      setValue("pqFumigation", state?.pqFumigation);
      setValue("fumigationCharge", state?.fumigationCharges);
      setValue("containersNumber", state?.containersNumber);
      setValue("dueDate", moment(state?.dueDate).format("YYYY-MM-DD"));
      setValue(
        "bankDeductionDate",
        moment(state?.bankDeductionDate).format("YYYY-MM-DD")
      );
      setValue("commodify", state?.commodify);
      setValue("exchangeRate", state?.exchangeRate);
      setValue(
        "dateOfShipping",
        moment(state?.dateOfShipping).format("YYYY-MM-DD")
      );

      setValue(
        "forwardContractDate",
        moment(state?.forwardContractDate).format("YYYY-MM-DD")
      );
      setValue("etaDate", state?.etaDate);
      setValue("fileName", state?.fileName);
      setValue("forwardcontractamount", state?.contractAmount);
      setValue("cfsCharges", state?.cfsCharges);
      setValue("chaSurvey", state?.chaSurvey);
      setValue("freightCharge", state?.freightCharge);
      setValue("unLoading", state?.unloading);
      setValue("extraExpenses", state?.extraExpenses);
      setValue("totalCft", state?.totalCft);
      setValue("totalInt", state?.totalInt);
      setValue("od", state?.od);
      setValue("sec49", state?.sec49);
      setValue("cfsGroundRent", state?.cfsGroundRent);
      setValue("examinationCharge", state?.examinationCharge);
      setValue("agents", state?.agents);
      setValue("yardRent", state?.yardRent);
      setValue("cfsName", state?.cfsName);

      // setValue("totalIndirectExpenses", state?.totalIndirectExpenses);

      setValue(
        "dutyPaymentDate",
        moment(state?.dutyPaymentDate).format("YYYY-MM-DD")
      );
      setValue("cost", state?.cost);
      setValue("examinationChargenew", state?.examinationChargenew);
      setValue("cfsGroundRentNew", state?.cfsGroundRentNew);
      setValue("freightChargeNew", state?.freightChargeNew);
      setValue("unloadingNew", state?.unloadingNew);
      setValue("sec49New", state?.sec49New);
      setValue("yardRentNew", state?.yardRentNew);
      // ===== Bank Details =====
      setValue("bankDetailsM1Date", state?.bankDetailsM1Date);
      setValue("bankDetailsM1Value", state?.bankDetailsM1Value);
      setValue("bankDetailsM1Dom", state?.bankDetailsM1Dom);
      setValue("bankDetailsM1Mv", state?.bankDetailsM1Mv);
      setValue("bankDetailsM2Date", state?.bankDetailsM2Date);
      setValue("bankDetailsM2Value", state?.bankDetailsM2Value);
      setValue("bankDetailsM2Dom", state?.bankDetailsM2Dom);
      setValue("bankDetailsM2Mv", state?.bankDetailsM2Mv);
      setValue("rolloverdays", state?.rolloverdays);
      setValue("rolloverType", state?.rolloverType);

      // ===== Rollover Same BG =====
      setValue(
        "rolloverSameBgUpfrontCharges",
        state?.rolloverSameBgUpfrontCharges
      );
      setValue(
        "rolloverSameBgForeignBankName",
        state?.rolloverSameBgForeignBankName
      );

      setValue("rolloverSameBgM3", state?.rolloverSameBgM3);
      setValue("rolloverSameBgM3Date", state?.rolloverSameBgM3Date);
      setValue("rolloverSameBgM3Value", state?.rolloverSameBgM3Value);
      setValue("rolloverSameBgM3Dom", state?.rolloverSameBgM3Dom);
      setValue("rolloverSameBgM3Mv", state?.rolloverSameBgM3Mv);

      setValue("rolloverSameBgBgNumber", state?.rolloverSameBgBgNumber);
      setValue("rolloverSameBgBgDate", state?.rolloverSameBgBgDate);
      setValue("rolloverSameBgBgCharges", state?.rolloverSameBgBgCharges);
      setValue(
        "rolloverSameBgSblcInterestCharges",
        state?.rolloverSameBgSblcInterestCharges
      );
      setValue("rolloverSameBgDueDate", state?.rolloverSameBgDueDate);

      setValue("rolloverSameBgAdvice", state?.rolloverSameBgAdvice);
      setValue("rolloverSameBgAdviceGst", state?.rolloverSameBgAdviceGst);
      setValue("rolloverSameBgExchangeRate", state?.rolloverSameBgExchangeRate);
      setValue(
        "rolloverSameBgBankDeductingDate",
        state?.rolloverSameBgBankDeductingDate
      );
      setValue(
        "rolloverSameBgForwardCoverDate",
        state?.rolloverSameBgForwardCoverDate
      );
      setValue(
        "rolloverSameBgForwardCoveredAmt",
        state?.rolloverSameBgForwardCoveredAmt
      );

      // ===== Rollover New BG =====
      setValue(
        "rolloverNewBgUpfrontCharges",
        state?.rolloverNewBgUpfrontCharges
      );
      setValue(
        "rolloverNewBgForeignBankName",
        state?.rolloverNewBgForeignBankName
      );

      setValue("rolloverNewBgM1", state?.rolloverNewBgM1);
      setValue("rolloverNewBgM1Date", state?.rolloverNewBgM1Date);
      setValue("rolloverNewBgM1Value", state?.rolloverNewBgM1Value);
      setValue("rolloverNewBgM1Dom", state?.rolloverNewBgM1Dom);
      setValue("rolloverNewBgM1Mv", state?.rolloverNewBgM1Mv);

      setValue("rolloverNewBgM2", state?.rolloverNewBgM2);
      setValue("rolloverNewBgM2Date", state?.rolloverNewBgM2Date);
      setValue("rolloverNewBgM2Value", state?.rolloverNewBgM2Value);
      setValue("rolloverNewBgM2Dom", state?.rolloverNewBgM2Dom);
      setValue("rolloverNewBgM2Mv", state?.rolloverNewBgM2Mv);

      setValue("rolloverNewBgBgNumber", state?.rolloverNewBgBgNumber);
      setValue("rolloverNewBgBgDate", state?.rolloverNewBgBgDate);
      setValue("rolloverNewBgBgCharges", state?.rolloverNewBgBgCharges);
      setValue(
        "rolloverNewBgSblcInterestCharges",
        state?.rolloverNewBgSblcInterestCharges
      );
      setValue("rolloverNewBgDueDate", state?.rolloverNewBgDueDate);

      setValue("rolloverNewBgAdvice", state?.rolloverNewBgAdvice);
      setValue("rolloverNewBgAdviceGst", state?.rolloverNewBgAdviceGst);
      setValue("rolloverNewBgExchangeRate", state?.rolloverNewBgExchangeRate);
      setValue(
        "rolloverNewBgBankDeductingDate",
        state?.rolloverNewBgBankDeductingDate
      );
      setValue(
        "rolloverNewBgForwardCoverDate",
        state?.rolloverNewBgForwardCoverDate
      );
      setValue(
        "rolloverNewBgForwardCoveredAmt",
        state?.rolloverNewBgForwardCoveredAmt
      );

      if (state?.userForm) {
        state?.userForm?.map((formItem, index) => {
          append();
          setValue(`dataEntryForm.${index}.containerNo`, formItem?.containerNo);
          setValue(
            `dataEntryForm.${index}.averageLength`,
            formItem?.averageLength
          );
          setValue(
            `dataEntryForm.${index}.avgCftAvgGirth`,
            formItem?.avgCftAvgGirth
          );
          setValue(`dataEntryForm.${index}.pcs`, formItem?.pcs);
          setValue(`dataEntryForm.${index}.plCbm`, formItem?.plCbm);
          setValue(`dataEntryForm.${index}.grossCbm`, formItem?.grossCbm);
          setValue(`dataEntryForm.${index}.netCbm`, formItem?.netCbm);
          setValue(`dataEntryForm.${index}.avgRate`, formItem?.avgRate);
          setValue(`dataEntryForm.${index}.amt`, formItem?.amt);
          setValue(`dataEntryForm.${index}.lorry`, formItem?.lorry);
          setValue(`dataEntryForm.${index}.sellRate`, formItem?.sellRate);
          setValue(`dataEntryForm.${index}.sellCbm`, formItem?.sellCbm);
          setValue(`dataEntryForm.${index}.brijeshComm`, formItem?.brijeshComm);
          setValue(`dataEntryForm.${index}.agent`, formItem?.agent);
          setValue(`dataEntryForm.${index}.pkl`, formItem?.pkl);
          setValue(`dataEntryForm.${index}.status`, formItem?.status);
          setContainerFileNamesImg((prev) => {
            const updatedFileNames = [
              {
                fileName: [],
                base64Files: [],
              },
            ];
            state?.userForm.forEach((item, index) => {
              if (!item?.containerImage) {
                console.warn(`Missing containerImage at index ${index}`);
                return;
              }

              item.containerImage.forEach((base64File, idx) => {
                if (base64File === "") {
                  console.log(
                    `Base64 file at index ${idx} in item ${index} is empty.`
                  );
                } else {
                  if (!updatedFileNames[index]) {
                    updatedFileNames[index] = { fileName: [], base64Files: [] };
                  }
                  updatedFileNames[index].fileName.push(`file${idx + 1}`);
                  updatedFileNames[index].base64Files.push(base64File);
                }
              });
            });

            return updatedFileNames; // Return the updated state.
          });
        });
        const newFieldsCount = state?.userForm.length;
        const currentFieldsCount = fields?.length;
      }
      // {
      //   copydocs &&
      //     setFileList((prev) => ({
      //       ...prev,
      //       // copydocs: [...(prev?.copydocs || []), ...copydocs && copydocs],
      //       copydocs: [
      //         ...(prev?.copydocs || []),
      //         ...Object.values(copydocs && copydocs),
      //       ],
      //     }));
      // }

      // // setFileList
      // setFileUploading((prevState) => [
      //   {
      //     summaryDoc: {
      //       file: state?.summarydocument !== null ? state?.summarydocument : "",
      //       name: state?.summarydocument !== null ? "SummaryDoc" : "",
      //     },
      //   },
      // ]);
      // setValue("summaryDoc", state?.summaryDocument);
      setValue("totalPcs", state?.totalPcs);
      setValue("totalGrossCbm", state?.totalGrossCbm);
      setValue("totalNetCbm", state?.totalNetCbm);
      setValue("totalAvgRate", state?.totalAvgRate);
      setValue("totalAmount", state?.totalAmount);
      setValue("roundOff", state?.roundOff);
      setValue("totalInvoiceAmt", state?.totalInvoiceAmount);
      setValue("brijesh", state?.bruesh);

      // state?.summarydocument !== null ? (
      //   setSelectedFile("summarydocument")
      // ) : (
      //   <></>
      // );

      // setValue("summaryDoc", selectedFile?.name);
    }
  }, [setValue, state, append, remove]);

  useEffect(() => {
    if (copydocs && Object.values(copydocs).length) {
      const docs = Object.values(copydocs);
      setFileList(docs);
    }
  }, [copydocs]);

  const filesvalue = [
    {
      name: "QUOTE DOCUMENT",
      state: state?.quotedocument ? state?.quotedocument : null,
    },
    {
      name: "DRAFT BL DOCUMENT",
      state: state?.bldocument ? state?.bldocument : null,
    },
    {
      name: "ROLLOVER DOCUMENT",
      state: state?.rollOverDocument ? state?.rollOverDocument : null,
    },
  ];

  // NEw Update Start
  const [isEditable, setIsEditable] = useState({
    fileName: false,
    billno: false,
    pqWeightcheck: false,
    pqWeight: false,
    pqfumigation: false,
    containersNumber: false,
    commodify: false,
    exporter: false,
    address: false,
    invoiceQuantity: false,
    invoiceRate: false,
    sblcInterestUsdRate: false,
    bgAmtInterestAmt: false,
    upFrontCharges: false,
    foreignBankName: false,
    M1AccountNumber: false,
    M2AccountNumber: false,
    margin10: false,
    margin5: false,
    bgNumber: false,
    beDate: false,
    bgDate: false,
    dateOfShipping: false,
    dueDate: false,
    dutyPaymentDate: false,
    etaDate: false,
    forwardContractDate: false,
    invoiceDt: false,
    bankDeductionDate: false,
    bgCharges: false,
    sblcInterestCharges: false,
    advice: false,
    adviceGst: false,

    exchangeRate: false,
    forwardcontractamount: false,
    beNo: false,

    beUsd: false,

    socialwelfarecharge: false,
    beIgst: false,
    assessValue: false,
    shippingBill: false,
    cfsName: false,
    chaSurvey: false,
    cfsCharges: false,
    examinationCharge: false,
    cfsGroundRent: false,
    freightCharge: false,
    unLoading: false,
    extraExpenses: false,
    sec49: false,
    fumigationCharge: false,
    dataEntryForm: {},
  });

  const handleEditConfirmation = (fieldName, index = null) => {
    const existingValue = watch(fieldName);

    if (existingValue) {
      const userConfirmed = window.confirm("Are you sure you want to edit?");
      if (userConfirmed) {
        setIsEditable((prev) => {
          if (index !== null) {
            // For dynamic fields
            return {
              ...prev,
              dataEntryForm: {
                ...prev?.dataEntryForm,
                [index]: true,
              },
            };
          }
          // For normal fields
          return { ...prev, [fieldName]: true };
        });
      }
    }
  };

  const handleInputFocus = (fieldName, index = null) => {
    handleEditConfirmation(fieldName, index);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isIndexing, setIsIndexing] = useState();

  const toggleDrawergf =
    (open, index = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      setIsOpen(open);
      setIsIndexing(index);
    };

  // GOTO NEXT TAB SELECTION
  const goToNextTab = () => {
    const currentIndex = tabs?.findIndex((tab) => tab?.id == activeTab);
    const nextTab = tabs[currentIndex + 1];
    if (nextTab) {
      setActiveTab(nextTab?.id);
    }
  };

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);

    return () => {
      // Clear on navigating away (component unmount)
      localStorage.removeItem("activeTab");
    };
  }, [activeTab]);

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="entry-form-block px-3 py-2"
      >
        <div className="tabs-container">
          {tabs &&
            tabs?.map((tab, i) => (
              <button
                key={tab?.id}
                className={`tab-button ${
                  activeTab === tab?.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab?.id)}
                type="button"
              >
                {tab?.label}
              </button>
            ))}
        </div>
        {activeTab === "bl" && (
          <>
            {/* BL DETAILS START */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">BL DETAILS</h6>
            </div>
            <div className="row py-2">
              {/* File Name */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.fileName}</label>
                <Controller
                  control={control}
                  name="fileName"
                  render={({ field }) => {
                    const hasValue = watch("fileName");
                    props.setShowFileName(hasValue);
                    return (
                      <input
                        {...field}
                        type="text"
                        className="data-entry-input-field"
                        placeholder="F1"
                        readOnly={hasValue && !isEditable.fileName}
                        onClick={() => handleInputFocus("fileName")}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                      />
                    );
                  }}
                />
              </div>

              {/* Bill Number */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.billnumber}</label>
                <Controller
                  control={control}
                  name="billno"
                  render={({ field }) => {
                    const hasValue = watch("billno");
                    return (
                      <input
                        {...field}
                        type="text"
                        className="data-entry-input-field"
                        placeholder="3421631"
                        readOnly={hasValue && !isEditable.billno}
                        disabled={state?.blNo}
                        onClick={() => handleInputFocus("billno")}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                      />
                    );
                  }}
                />
              </div>

              {/* Date of Shipping */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {Strings.dateofshipping}
                </label>
                <Controller
                  name="dateOfShipping"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("dateOfShipping") ? "--BG_VVV" : ""
                      }`}
                      onChange={(e) => {
                        handleInputFocus("dateOfShipping");
                        setIsEditable((prev) => ({
                          ...prev,
                          dateOfShipping: false,
                        }));
                        field.onChange(e.target.value || null);
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.etadate}</label>
                <Controller
                  name="etaDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("etaDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(e) => {
                        handleInputFocus("etaDate");
                        setIsEditable((prev) => ({
                          ...prev,
                          etaDate: false,
                        }));
                        field.onChange(e.target.value || null);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.pqweight}</label>
                <Controller
                  control={control}
                  name="pqWeightcheck"
                  render={({ field }) => {
                    const hasValue = watch("pqWeightcheck");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="pqWeightcheck"
                        readOnly={hasValue && !isEditable.pqWeightcheck}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        // onFocus={() => setIsEditable((prev) => ({ ...prev, fileName: true }))}
                        onClick={() => handleInputFocus("pqWeightcheck")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">PQ WEIGHT 4*:</label>
                <Controller
                  control={control}
                  name="pqWeight"
                  render={({ field }) => {
                    const hasValue = watch("pqWeight");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.pqWeight}
                        // disable={state?.blNo ? true : false}
                        // onFocus={() => setIsEditable((prev) => ({ ...prev, exporter: true }))}
                        onClick={() => handleInputFocus("pqWeight")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.pqfumigation}
                </label>
                <Controller
                  control={control}
                  name="pqFumigation"
                  render={({ field }) => {
                    const hasValue = watch("pqfumigation");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.pqfumigation}
                        // disable={state?.blNo ? true : false}
                        // onFocus={() => setIsEditable((prev) => ({ ...prev, exporter: true }))}
                        onClick={() => handleInputFocus("pqfumigation")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.containersno}
                </label>
                <Controller
                  control={control}
                  name="containersNumber"
                  render={({ field }) => {
                    const hasValue = watch("containersNumber");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.containersNumber}
                        onClick={() => handleInputFocus("containersNumber")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.commodify}</label>
                <Controller
                  control={control}
                  name="commodify"
                  render={({ field }) => {
                    const hasValue = watch("commodify");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="Commodify"
                        readOnly={hasValue && !isEditable.commodify}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        // onFocus={() => setIsEditable((prev) => ({ ...prev, fileName: true }))}
                        onClick={() => handleInputFocus("commodify")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            {/* BL DETAILS END */}
          </>
        )}

        {activeTab === "inv" && (
          <>
            {/* Invoice details Start */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">INVOICE DETAILS</h6>
            </div>
            {/* INVOICE DETAILS START */}

            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.exporter}</label>
                <Controller
                  control={control}
                  name="exporter"
                  render={({ field }) => {
                    const hasValue = watch("exporter");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="THIRU RANI LOGISTICS PVT LTD"
                        readOnly={hasValue && !isEditable.exporter}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("exporter")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-8 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label --modifier-label">
                  {" "}
                  {Strings.address}
                </label>
                <Controller
                  control={control}
                  name="address"
                  render={({ field }) => {
                    const hasValue = watch("address");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.address}
                        // disable={state?.blNo ? true : false}
                        onClick={() => handleInputFocus("address")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.invoiceno}</label>
                <Controller
                  control={control}
                  name="invoiceno"
                  render={({ field }) => {
                    const hasValue = watch("invoiceno");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="invoiceno"
                        readOnly={hasValue && !isEditable.invoiceno}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("invoiceno")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">{Strings.invoicedt}</label>
                <Controller
                  name="invoicedt"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("invoicedt") ? "--BG_VVV" : ""
                      }`}
                      onChange={(e) => {
                        handleInputFocus("invoicedt");
                        setIsEditable((prev) => ({
                          ...prev,
                          invoicedt: false,
                        }));
                        field.onChange(e.target.value || null);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {Strings.invoicequantity}
                </label>
                <Controller
                  control={control}
                  name="invoiceQuantity"
                  render={({ field }) => {
                    const hasValue = watch("invoiceQuantity");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.invoiceQuantity}
                        // disable={state?.blNo ? true : false}
                        onClick={() => handleInputFocus("invoiceQuantity")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.invoicerate}
                </label>
                <Controller
                  control={control}
                  name="invoiceRate"
                  render={({ field }) => {
                    const hasValue = watch("invoiceRate");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.invoiceRate}
                        // disable={state?.blNo ? true : false}
                        onClick={() => handleInputFocus("invoiceRate")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.sblcinterestusdrate}
                </label>
                <Controller
                  control={control}
                  name="sblcInterestUsdRate"
                  render={({ field }) => {
                    const hasValue = watch("sblcInterestUsdRate");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="sblcInterestUsdRate"
                        readOnly={hasValue && !isEditable.sblcInterestUsdRate}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("sblcInterestUsdRate")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {Strings.bgamt_interestamt}
                </label>
                <Controller
                  control={control}
                  name="bgAmtInterestAmt"
                  render={({ field }) => {
                    const hasValue = watch("bgAmtInterestAmt");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="bgAmtInterestAmt"
                        readOnly={hasValue && !isEditable.bgAmtInterestAmt}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("bgAmtInterestAmt")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {/* Invoice details END */}
          </>
        )}
        {activeTab === "bank" && (
          <>
            {/* Banking Start */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">BANK DETAILS</h6>
            </div>
            {/* Banking START */}
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.upfrontcharges}
                </label>
                <Controller
                  control={control}
                  name="upFrontCharges"
                  render={({ field }) => {
                    const hasValue = watch("upFrontCharges");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="upFrontCharges"
                        readOnly={hasValue && !isEditable.upFrontCharges}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("upFrontCharges")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-8 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label --modifier-label">
                  {" "}
                  {/* {Strings.foreignbankname} */}
                  FOR. BANK NAME :
                </label>
                <Controller
                  control={control}
                  name="foreignBankName"
                  render={({ field }) => {
                    const hasValue = watch("foreignBankName");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="foreignBankName"
                        readOnly={hasValue && !isEditable.foreignBankName}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("foreignBankName")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">
                  {/* {Strings.m1accountnumber} */}
                  M1 NUMBER :
                </label>
                <Controller
                  control={control}
                  name="M1AccountNumber"
                  render={({ field }) => {
                    const hasValue = watch("M1AccountNumber");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="M1AccountNumber"
                        readOnly={hasValue && !isEditable.M1AccountNumber}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("M1AccountNumber")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M1 DATE :</label>
                <Controller
                  name="bankDetailsM1Date"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bankDetailsM1Date") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bankDetailsM1Date");
                        setIsEditable((prev) => ({
                          ...prev,
                          bankDetailsM1Date: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M1 VALUE :</label>
                {/* margin10--->m1 value */}
                <Controller
                  control={control}
                  name="margin10"
                  render={({ field }) => {
                    const hasValue = watch("margin10");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.margin10}
                        onClick={() => handleInputFocus("margin10")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M1- DOM :</label>
                <Controller
                  name="bankDetailsM1Dom"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bankDetailsM1Dom") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bankDetailsM1Dom");
                        setIsEditable((prev) => ({
                          ...prev,
                          bankDetailsM1Dom: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M1- MV :</label>
                <Controller
                  control={control}
                  name="bankDetailsM1Mv"
                  render={({ field }) => {
                    const hasValue = watch("bankDetailsM1Mv");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="M1 MV"
                        readOnly={hasValue && !isEditable.bankDetailsM1Mv}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("bankDetailsM1Mv")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">
                  {/* {Strings.m2accountnumber} */}
                  M2 NUMBER :
                </label>
                <Controller
                  control={control}
                  name="M2AccountNumber"
                  render={({ field }) => {
                    const hasValue = watch("M2AccountNumber");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="M2AccountNumber"
                        readOnly={hasValue && !isEditable.M2AccountNumber}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("M2AccountNumber")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M2 DATE :</label>
                <Controller
                  name="bankDetailsM2Date"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bankDetailsM2Date") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bankDetailsM2Date");
                        setIsEditable((prev) => ({
                          ...prev,
                          bankDetailsM2Date: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M2 VALUE :</label>
                <Controller
                  control={control}
                  name="margin5"
                  render={({ field }) => {
                    const hasValue = watch("margin5");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.margin5}
                        onClick={() => handleInputFocus("margin5")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M2-DOM :</label>
                <Controller
                  name="bankDetailsM2Dom"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bankDetailsM2Dom") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bankDetailsM2Dom");
                        setIsEditable((prev) => ({
                          ...prev,
                          bankDetailsM2Dom: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">M2-MV :</label>
                <Controller
                  control={control}
                  name="bankDetailsM2Mv"
                  render={({ field }) => {
                    const hasValue = watch("bankDetailsM2Mv");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="M2-MV"
                        readOnly={hasValue && !isEditable.bankDetailsM2Mv}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("bankDetailsM2Mv")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">BG NUMBER</label>
                <Controller
                  control={control}
                  name="bgNumber"
                  render={({ field }) => {
                    const hasValue = watch("bgNumber");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="bgNumber"
                        readOnly={hasValue && !isEditable.bgNumber}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("bgNumber")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">BG DATE</label>
                <Controller
                  name="bgDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bgDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bgDate");
                        setIsEditable((prev) => ({ ...prev, bgDate: false }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">{Strings.bgcharges}</label>
                <Controller
                  control={control}
                  name="bgCharges"
                  render={({ field }) => {
                    const hasValue = watch("bgCharges");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.bgCharges}
                        onClick={() => handleInputFocus("bgCharges")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">
                  {/* {Strings.sblcinterest_charges} */}
                  SBLC INT & CHARGES :
                </label>
                <Controller
                  control={control}
                  name="sblcInterestCharges"
                  render={({ field }) => {
                    const hasValue = watch("sblcInterestCharges");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.sblcInterestCharges}
                        onClick={() => handleInputFocus("sblcInterestCharges")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">{Strings.duedate}</label>
                <Controller
                  name="dueDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("dueDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("dueDate");
                        setIsEditable((prev) => ({
                          ...prev,
                          dueDate: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">{Strings.advice}</label>
                <Controller
                  control={control}
                  name="advice"
                  render={({ field }) => {
                    const hasValue = watch("advice");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="advice"
                        readOnly={hasValue && !isEditable.advice}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("advice")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">{Strings.advicegst}</label>
                <Controller
                  control={control}
                  name="adviceGst"
                  render={({ field }) => {
                    const hasValue = watch("adviceGst");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="adviceGst"
                        readOnly={hasValue && !isEditable.adviceGst}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("adviceGst")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">
                  {Strings.exchangerate}
                </label>
                <Controller
                  control={control}
                  name="exchangeRate"
                  render={({ field }) => {
                    const hasValue = watch("exchangeRate");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="exchangeRate"
                        readOnly={hasValue && !isEditable.exchangeRate}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("exchangeRate")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">
                  {/* {Strings.bankdeductiondate} */}
                  BANK DEDUCT DATE :
                </label>
                <Controller
                  name="bankDeductionDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("bankDeductionDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("bankDeductionDate");
                        setIsEditable((prev) => ({
                          ...prev,
                          bankDeductionDate: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col mb-3 d-flex flex-column">
                <label className="responsive-label">FWD COVERED DATE : </label>
                <Controller
                  name="forwardContractDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("forwardContractDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("forwardContractDate");
                        setIsEditable((prev) => ({
                          ...prev,
                          forwardContractDate: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {/* {Strings.forwardcontractamount} */}
                  FWD COVERED AMT :
                </label>
                <Controller
                  control={control}
                  name="forwardcontractamount"
                  render={({ field }) => {
                    const hasValue = watch("forwardcontractamount");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="forwardcontractamount"
                        readOnly={hasValue && !isEditable.forwardcontractamount}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() =>
                          handleInputFocus("forwardcontractamount")
                        }
                      />
                    );
                  }}
                />
              </div>
            </div>

            <hr />
            <div className="row">
              <div className="col-12 col-lg-4">
                <Controller
                  control={control}
                  name="rolloverType"
                  defaultValue="sameBg"
                  render={({ field }) => {
                    const hasValue = watch("rolloverType");
                    return (
                      <select
                        className="data-entry-input-field my-3"
                        {...field}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="sameBg">ROLLOVER SAME BG</option>
                        <option value="newBg">ROLLOVER NEW BG</option>
                      </select>
                    );
                  }}
                />
              </div>
              <div className="col-12 col-lg-4">
                <Controller
                  control={control}
                  name="rolloverdays"
                  render={({ field }) => {
                    const hasValue = watch("rolloverdays");
                    return (
                      <input
                        className="data-entry-input-field my-3"
                        {...field}
                        type="number"
                        placeholder="Tenor Days"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.rolloverdays}
                        // disable={state?.blNo ? true : false}
                        onClick={() => handleInputFocus("rolloverdays")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {rolloverType == "sameBg" ? (
              <>
                <div className="row py-2">
                  <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                    <label className="responsive-label">
                      {" "}
                      UPFRONT CHARGES :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverSameBgUpfrontCharges"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgUpfrontCharges");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverSameBgUpfrontCharges
                            }
                            // disable={state?.blNo ? true : false}
                            onClick={() =>
                              handleInputFocus("rolloverSameBgUpfrontCharges")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-8 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                    <label className="responsive-label --modifier-label">
                      {" "}
                      FOR. BANK NAME :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverSameBgForeignBankName"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgForeignBankName");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="Bank Name"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverSameBgForeignBankName
                            }
                            // disable={state?.blNo ? true : false}
                            onClick={() =>
                              handleInputFocus("rolloverSameBgForeignBankName")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M3 :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgM3"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgM3");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={hasValue && !isEditable.rolloverSameBgM3}
                            onClick={() => handleInputFocus("rolloverSameBgM3")}
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M3 DATE :</label>
                    <Controller
                      name="rolloverSameBgM3Date"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgM3Date") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgM3Date");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgM3Date: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M3 VALUE :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgM3Value"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgM3Value");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgM3Value
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgM3Value")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M3- DOM :</label>
                    <Controller
                      name="rolloverSameBgM3Dom"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgM3Dom") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgM3Dom");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgM3Dom: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M3- MV :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgM3Mv"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgM3Mv");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgM3Mv
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgM3Mv")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG NUMBER :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgBgNumber"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgBgNumber");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgBgNumber
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgBgNumber")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG DATE :</label>
                    <Controller
                      name="rolloverSameBgBgDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgBgDate") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgBgDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgBgDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG CHARGES :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgBgCharges"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgBgCharges");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgBgCharges
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgBgCharges")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      SBLC INT & CHARGES :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverSameBgSblcInterestCharges"
                      render={({ field }) => {
                        const hasValue = watch(
                          "rolloverSameBgSblcInterestCharges"
                        );
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverSameBgSblcInterestCharges
                            }
                            onClick={() =>
                              handleInputFocus(
                                "rolloverSameBgSblcInterestCharges"
                              )
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">DUE DATE :</label>
                    <Controller
                      name="rolloverSameBgDueDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgDueDate") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgDueDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgDueDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">ADVICE :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgAdvice"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgAdvice");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgAdvice
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgAdvice")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">ADVICE GST :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgAdviceGst"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgAdviceGst");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgAdviceGst
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgAdviceGst")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">EXCHANGE RATE :</label>
                    <Controller
                      control={control}
                      name="rolloverSameBgExchangeRate"
                      render={({ field }) => {
                        const hasValue = watch("rolloverSameBgExchangeRate");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverSameBgExchangeRate
                            }
                            onClick={() =>
                              handleInputFocus("rolloverSameBgExchangeRate")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      BANK DEDUCT DATE :
                    </label>
                    <Controller
                      name="rolloverSameBgBankDeductingDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgBankDeductingDate")
                              ? "--BG_VVV"
                              : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgBankDeductingDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgBankDeductingDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      FWD COVER DATE :{" "}
                    </label>
                    <Controller
                      name="rolloverSameBgForwardCoverDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverSameBgForwardCoverDate")
                              ? "--BG_VVV"
                              : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverSameBgForwardCoverDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverSameBgForwardCoverDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      FWD COVERED AMT :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverSameBgForwardCoveredAmt"
                      render={({ field }) => {
                        const hasValue = watch(
                          "rolloverSameBgForwardCoveredAmt"
                        );
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverSameBgForwardCoveredAmt
                            }
                            onClick={() =>
                              handleInputFocus(
                                "rolloverSameBgForwardCoveredAmt"
                              )
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row py-2">
                  <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                    <label className="responsive-label --modifier-label">
                      {" "}
                      UPFRONT CHARGES :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverNewBgUpfrontCharges"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgUpfrontCharges");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverNewBgUpfrontCharges
                            }
                            // disable={state?.blNo ? true : false}
                            onClick={() =>
                              handleInputFocus("rolloverNewBgUpfrontCharges")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-8 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                    <label className="responsive-label">
                      {" "}
                      FOR. BANK NAME :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverNewBgForeignBankName"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgForeignBankName");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="Bank Name"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverNewBgForeignBankName
                            }
                            // disable={state?.blNo ? true : false}
                            onClick={() =>
                              handleInputFocus("rolloverNewBgForeignBankName")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M1 :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM1"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM1");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={hasValue && !isEditable.rolloverNewBgM1}
                            onClick={() => handleInputFocus("rolloverNewBgM1")}
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M1 DATE :</label>
                    <Controller
                      name="rolloverNewBgM1Date"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgM1Date") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgM1Date");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgM1Date: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M1 VALUE :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM1Value"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM1Value");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgM1Value
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgM1Value")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M1 - DOM :</label>
                    <Controller
                      name="rolloverNewBgM1Dom"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgM1Dom") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgM1Dom");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgM1Dom: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M1 - MV :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM1Mv"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM1Mv");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={hasValue && !isEditable.rolloverNewBgM1Mv}
                            onClick={() =>
                              handleInputFocus("rolloverNewBgM1Mv")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M2 :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM2"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM2");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={hasValue && !isEditable.rolloverNewBgM2}
                            onClick={() => handleInputFocus("rolloverNewBgM2")}
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M2 DATE :</label>
                    <Controller
                      name="rolloverNewBgM2Date"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgM2Date") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgM2Date");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgM2Date: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M2 VALUE :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM2Value"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM2Value");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgM2Value
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgM2Value")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M2 - DOM :</label>
                    <Controller
                      name="rolloverNewBgM2Dom"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgM2Dom") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgM2Dom");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgM2Dom: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">M2 - MV :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgM2Mv"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgM2Mv");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={hasValue && !isEditable.rolloverNewBgM2Mv}
                            onClick={() =>
                              handleInputFocus("rolloverNewBgM2Mv")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG NUMBER :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgBgNumber"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgBgNumber");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="text"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgBgNumber
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgBgNumber")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG DATE :</label>
                    <Controller
                      name="rolloverNewBgBgDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgBgDate") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgBgDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgBgDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BG CHARGES :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgBgCharges"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgBgCharges");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgBgCharges
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgBgCharges")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      SBLC INT & CHARGES :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverNewBgSblcInterestCharges"
                      render={({ field }) => {
                        const hasValue = watch(
                          "rolloverNewBgSblcInterestCharges"
                        );
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverNewBgSblcInterestCharges
                            }
                            onClick={() =>
                              handleInputFocus(
                                "rolloverNewBgSblcInterestCharges"
                              )
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">DUE DATE :</label>
                    <Controller
                      name="rolloverNewBgDueDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgDueDate") ? "--BG_VVV" : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgDueDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgDueDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 py-2">
                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">ADVICE :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgAdvice"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgAdvice");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgAdvice
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgAdvice")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">ADVICE GST :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgAdviceGst"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgAdviceGst");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgAdviceGst
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgAdviceGst")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">EXCHANGE RATE :</label>
                    <Controller
                      control={control}
                      name="rolloverNewBgExchangeRate"
                      render={({ field }) => {
                        const hasValue = watch("rolloverNewBgExchangeRate");
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue && !isEditable.rolloverNewBgExchangeRate
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgExchangeRate")
                            }
                          />
                        );
                      }}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">BANK DEDUCT DATE</label>
                    <Controller
                      name="rolloverNewBgBankDeductingDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgBankDeductingDate")
                              ? "--BG_VVV"
                              : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgBankDeductingDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgBankDeductingDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">FWD COVER DATE :</label>
                    <Controller
                      name="rolloverNewBgForwardCoverDate"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className={`data-entry-date-field ${
                            watch("rolloverNewBgForwardCoverDate")
                              ? "--BG_VVV"
                              : ""
                          }`}
                          onChange={(date) => {
                            handleInputFocus("rolloverNewBgForwardCoverDate");
                            setIsEditable((prev) => ({
                              ...prev,
                              rolloverNewBgForwardCoverDate: false,
                            }));
                            field.onChange(date);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col mb-3 d-flex flex-column">
                    <label className="responsive-label">
                      FWD COVERED AMT :
                    </label>
                    <Controller
                      control={control}
                      name="rolloverNewBgForwardCoveredAmt"
                      render={({ field }) => {
                        const hasValue = watch(
                          "rolloverNewBgForwardCoveredAmt"
                        );
                        return (
                          <input
                            className="data-entry-input-field"
                            {...field}
                            type="number"
                            placeholder="3421631"
                            style={{
                              border: hasValue ? "1px solid #000" : "none",
                              background: hasValue
                                ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                : "#fff",
                            }}
                            readOnly={
                              hasValue &&
                              !isEditable.rolloverNewBgForwardCoveredAmt
                            }
                            onClick={() =>
                              handleInputFocus("rolloverNewBgForwardCoveredAmt")
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </>
            )}

            {/* Banking END */}
          </>
        )}

        {activeTab === "be" && (
          <>
            {/* BE details Start */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">BE DETAILS</h6>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.beno}</label>
                <Controller
                  control={control}
                  name="beNo"
                  render={({ field }) => {
                    const hasValue = watch("beNo");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="beNo"
                        readOnly={hasValue && !isEditable.beNo}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("beNo")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.bedate}</label>
                <Controller
                  name="beDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("beDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("beDate");
                        setIsEditable((prev) => ({ ...prev, beDate: false }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.beusd}</label>
                <Controller
                  control={control}
                  name="beUsd"
                  render={({ field }) => {
                    const hasValue = watch("beUsd");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="3421631"
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        readOnly={hasValue && !isEditable.beUsd}
                        // disable={state?.blNo ? true : false}
                        onClick={() => handleInputFocus("beUsd")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.duty_payment_date}
                </label>
                <Controller
                  name="dutyPaymentDate"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className={`data-entry-date-field ${
                        watch("dutyPaymentDate") ? "--BG_VVV" : ""
                      }`}
                      onChange={(date) => {
                        handleInputFocus("dutyPaymentDate");
                        setIsEditable((prev) => ({
                          ...prev,
                          dutyPaymentDate: false,
                        }));
                        field.onChange(date);
                      }}
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.customduty}
                </label>
                <Controller
                  control={control}
                  name="customDuty"
                  render={({ field }) => {
                    const hasValue = watch("customDuty");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="customDuty"
                        readOnly={hasValue && !isEditable.customDuty}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("customDuty")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.socialwelfarecharge}
                </label>
                <Controller
                  control={control}
                  name="socialWelfareCharges"
                  render={({ field }) => {
                    const hasValue = watch("socialWelfareCharges");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="socialWelfareCharges"
                        readOnly={hasValue && !isEditable.socialWelfareCharges}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("socialWelfareCharges")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.begst}</label>
                <Controller
                  control={control}
                  name="beIgst"
                  render={({ field }) => {
                    const hasValue = watch("beIgst");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="beIgst"
                        readOnly={hasValue && !isEditable.beIgst}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("beIgst")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.assessvalue}
                </label>
                <Controller
                  control={control}
                  name="assessValue"
                  render={({ field }) => {
                    const hasValue = watch("assessValue");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="assessValue"
                        readOnly={hasValue && !isEditable.assessValue}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("assessValue")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {/* BE details END */}
          </>
        )}

        {activeTab === "ship" && (
          <>
            {/* shipping bill Start */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">SHIPPING BILL</h6>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.shippingbill}
                </label>
                <Controller
                  control={control}
                  name="shippingBill"
                  render={({ field }) => {
                    const hasValue = watch("shippingBill");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="shippingBill"
                        readOnly={hasValue && !isEditable.shippingBill}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("shippingBill")}
                      />
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-8 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label --modifier-label">
                  {Strings.cfsname}
                </label>
                <Controller
                  control={control}
                  name="cfsName"
                  render={({ field }) => {
                    const hasValue = watch("cfsName");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="cfsName"
                        readOnly={hasValue && !isEditable.cfsName}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("cfsName")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {/* shipping bill END */}
            {/* CH & Other Expenses Start */}
            <div className="py-3">
              <h6 className="data-entry-sub-title">CH & Other Expenses</h6>
            </div>
            <div className="row py-2">
              {/* CFS Charges */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.cfscharges}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("cfsChargesNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="cfsCharges"
                  render={({ field }) => {
                    const hasValue = watch("cfsCharges");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="cfsCharges"
                        readOnly={hasValue && !isEditable.cfsCharges}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("cfsCharges")}
                      />
                    );
                  }}
                />
              </div>

              {/* CHA Survey */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.chasurvey}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("chaSurveyNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="chaSurvey"
                  render={({ field }) => {
                    const hasValue = watch("chaSurvey");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="chaSurvey"
                        readOnly={hasValue && !isEditable.chaSurvey}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("chaSurvey")}
                      />
                    );
                  }}
                />
              </div>

              {/* Examination Charge */}
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.examinationCharge}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("examinationChargenew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="examinationCharge"
                  render={({ field }) => {
                    const hasValue = watch("examinationCharge");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="examinationCharge"
                        readOnly={hasValue && !isEditable.examinationCharge}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("examinationCharge")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.cfsGroundRent}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("cfsGroundRentNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="cfsGroundRent"
                  render={({ field }) => {
                    const hasValue = watch("cfsGroundRent");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="cfsGroundRent"
                        readOnly={hasValue && !isEditable.cfsGroundRent}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("cfsGroundRent")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.freightcharge}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("freightChargeNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="freightCharge"
                  render={({ field }) => {
                    const hasValue = watch("freightCharge");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="freightCharge"
                        readOnly={hasValue && !isEditable.freightCharge}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("freightCharge")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.unloading}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("unloadingNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="unLoading"
                  render={({ field }) => {
                    const hasValue = watch("unLoading");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="unLoading"
                        readOnly={hasValue && !isEditable.unLoading}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("unLoading")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.extraexpences}
                  </label>
                  <input
                    placeholder="130000"
                    {...register("yardRentNew")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="extraExpenses"
                  render={({ field }) => {
                    const hasValue = watch("extraExpenses");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="extraExpenses"
                        readOnly={hasValue && !isEditable.extraExpenses}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("extraExpenses")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">{Strings.sec49}</label>
                  <input
                    placeholder="130000"
                    {...register("sec49New")}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="sec49"
                  render={({ field }) => {
                    const hasValue = watch("sec49");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="sec49"
                        readOnly={hasValue && !isEditable.sec49}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("sec49")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column">
                <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-3">
                  <label className="responsive-label">
                    {Strings.fumigationcharge}
                  </label>
                  <input
                    placeholder="130000"
                    style={{ visibility: "hidden" }}
                    className="small-input"
                  />
                </div>
                <Controller
                  control={control}
                  name="fumigationCharge"
                  render={({ field }) => {
                    const hasValue = watch("fumigationCharge");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="fumigationCharge"
                        readOnly={hasValue && !isEditable.fumigationCharge}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("fumigationCharge")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {/* CH & Other Expenses END */}
            {/* Calculation START */}
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.totalcft}</label>
                <Controller
                  control={control}
                  name="totalCft"
                  render={({ field }) => {
                    const hasValue = watch("totalCft");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="totalCft"
                        readOnly={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                        // onClick={() => handleInputFocus("totalCft")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.totalint}</label>
                <Controller
                  control={control}
                  name="totalInt"
                  render={({ field }) => {
                    const hasValue = watch("totalInt");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="totalInt"
                        // readOnly={hasValue && !isEditable.totalInt}
                        readOnly={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                        onClick={() => handleInputFocus("totalInt")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.agents}</label>
                <Controller
                  control={control}
                  name="agents"
                  render={({ field }) => {
                    const hasValue = watch("agents");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="agents"
                        readOnly={hasValue && !isEditable.agents}
                        disabled={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                        onClick={() => handleInputFocus("agents")}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.yardrent}</label>
                <Controller
                  control={control}
                  name="yardRent"
                  render={({ field }) => {
                    const hasValue = watch("yardRent");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="yardRent"
                        readOnly={hasValue && !isEditable.yardRent}
                        disabled={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                        onClick={() => handleInputFocus("yardRent")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.cost}</label>
                <Controller
                  control={control}
                  name="cost"
                  render={({ field }) => {
                    const hasValue = watch("cost");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="cost"
                        readOnly={hasValue && !isEditable.cost}
                        disabled={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                        onClick={() => handleInputFocus("cost")}
                      />
                    );
                  }}
                />
              </div>
            </div>

            {/* Calculation END */}
          </>
        )}

        {activeTab === "summary" && (
          <>
            {/* Table START */}
            <div style={{ overflow: "hidden" }} className="mt-5">
              <div style={{ width: "auto", overflowX: "scroll" }}>
                <table>
                  <thead>
                    <tr>
                      <th className="data-entry-label --append-label">
                        CONTAINER NO
                      </th>
                      <th className="data-entry-label --append-label">
                        AVG LENTH
                      </th>
                      <th className="data-entry-label --append-label">
                        AVG CFT/AVG GIRTH
                      </th>
                      <th className="data-entry-label --append-label">PCS</th>
                      <th className="data-entry-label --append-label">
                        BL CBM
                      </th>
                      <th className="data-entry-label --append-label">
                        GROSS CBM
                      </th>
                      <th className="data-entry-label --append-label">
                        NET CBM
                      </th>
                      <th className="data-entry-label --append-label">RATE</th>
                      <th className="data-entry-label --append-label">AMT</th>
                      <th className="data-entry-label --append-label">LORRY</th>
                      <th className="data-entry-label --append-label">
                        SELL RATE
                      </th>
                      <th className="data-entry-label --append-label">
                        SELL CBM
                      </th>
                      <th className="data-entry-label --append-label">
                        {/* BRIJESH COMM */}
                        BROKARAGE
                      </th>
                      <th className="data-entry-label --append-label">
                        AGENT NAME
                      </th>
                      <th className="data-entry-label --append-label">PKL</th>
                      <th className="data-entry-label --append-label">
                        STATUS
                      </th>
                      <th className="data-entry-label --append-label">IMAGE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields?.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.containerNo`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.containerNo`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="CMAU3843174"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.containerNo`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.averageLength`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.averageLength`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  type="number"
                                  step="any"
                                  placeholder="2.27"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.averageLength`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.avgCftAvgGirth`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.avgCftAvgGirth`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="5.43"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.avgCftAvgGirth`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.pcs`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.pcs`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  type="number"
                                  step="any"
                                  placeholder="121"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.pcs`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.plCbm`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.plCbm`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  type="number"
                                  step="any"
                                  placeholder="121"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.plCbm`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.grossCbm`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.grossCbm`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="121"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.grossCbm`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.netCbm`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.netCbm`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  step="any"
                                  placeholder="433.3"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.netCbm`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>

                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.avgRate`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.avgRate`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="17.160"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.avgRate`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.amt`}
                            render={({ field }) => (
                              <input
                                {...field}
                                placeholder="5.84"
                                type="number"
                                className="data-entry-input-field"
                                style={{ width: "auto" }}
                                step="any"
                                readOnly={true}
                                // onChange={(e) => {
                                //   field.onChange(e);
                                //   updateTotals();
                                // }}
                              />
                            )}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.lorry`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.lorry`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  type="text"
                                  placeholder="TN 25 AQ 7388"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.lorry`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.sellRate`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.sellRate`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="5.43"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.sellRate`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.sellCbm`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.sellCbm`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="7388"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.sellCbm`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.brijeshComm`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.brijeshComm`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="5.84"
                                  step="any"
                                  type="number"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onChange={(e) => {
                                    field.onChange(e);
                                    updateTotals();
                                  }}
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.brijeshComm`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.agent`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.agent`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="Agent Name"
                                  type="text"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.agent`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.pkl`}
                            render={({ field }) => {
                              const hasValue = watch(
                                `dataEntryForm.${index}.pkl`
                              );
                              return (
                                <input
                                  {...field}
                                  className="data-entry-input-field"
                                  placeholder="5.43"
                                  type="number"
                                  step="any"
                                  style={{
                                    border: hasValue
                                      ? "1px solid #000"
                                      : "none",
                                    background: hasValue
                                      ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                                      : "#fff",
                                    width: "auto",
                                  }}
                                  readOnly={
                                    hasValue &&
                                    !isEditable?.dataEntryForm[index]
                                  }
                                  onClick={() =>
                                    handleInputFocus(
                                      `dataEntryForm.${index}.pkl`,
                                      index
                                    )
                                  }
                                />
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.status`}
                            render={({ field }) => (
                              <select
                                className="data-entry-input-field"
                                {...field}
                                // onChange={(e) => field.onChange({ ...field.value })}
                                style={{ width: "auto" }}
                              >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            )}
                          />
                        </td>
                        <td>
                          <Controller
                            control={control}
                            name={`dataEntryForm.${index}.containerImage`}
                            render={({ field }) => (
                              <>
                                <input
                                  type="file"
                                  accept="image/*"
                                  ref={(el) => (imageRefs.current[index] = el)}
                                  style={{ display: "none" }}
                                  multiple
                                  onChange={(e) => {
                                    handleImageChange(index, e);
                                    field.onChange(e);
                                  }}
                                />
                                <div
                                  className="data-entry-input-field"
                                  style={{
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                  }}
                                  onClick={() =>
                                    imageRefs.current[index]?.click()
                                  }
                                >
                                  <div>
                                    <p style={{ margin: "0px" }}>ADD IMAGE</p>
                                  </div>
                                </div>
                              </>
                            )}
                          />
                          <div style={{ display: "flex" }}>
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              {containerfileNamesImg[index]?.fileName
                                ?.slice(0, 1)
                                .map((name, fileIndex) => (
                                  <>
                                    <div
                                      // key={fileIndex}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          width: "90px",
                                        }}
                                      >
                                        {name}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveFile(index, fileIndex)
                                        }
                                        style={{
                                          marginLeft: "10px",
                                          color: "red",
                                          border: "none",
                                          background: "transparent",
                                          cursor: "pointer",
                                        }}
                                      >
                                        &#x2716;
                                      </button>
                                    </div>
                                  </>
                                ))}

                              {containerfileNamesImg[index]?.fileName &&
                                containerfileNamesImg[index]?.fileName?.length >
                                  1 && (
                                  <Button
                                    variant="contained"
                                    onClick={toggleDrawergf(true, index)}
                                    style={{ marginLeft: "10px" }}
                                  >
                                    +{" "}
                                    {containerfileNamesImg[index]?.fileName
                                      .length - 1}
                                  </Button>
                                )}
                            </div>
                          </div>
                        </td>

                        <td>
                          <button
                            type="button"
                            onClick={() => {
                              append();
                              setIsEditable((prev) => ({
                                ...prev,
                                dataEntryForm: {
                                  ...prev?.dataEntryForm,
                                  [fields?.length]: false, // New field is not editable by default
                                },
                              }));
                            }}
                          >
                            +
                          </button>
                          {index > 0 && (
                            <div
                              className="imageIcon"
                              onClick={() => remove(index)}
                            >
                              <img
                                src={deleteIcon}
                                style={{ width: "100%", height: "100%" }}
                              />
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot style={{ background: "#9bc2e6" }}>
                    <tr>
                      <td className="data-entry-label --append-label text-center">
                        Total:
                      </td>
                      <td className="data-entry-label --append-label text-center"></td>
                      <td className="data-entry-label --append-label text-center"></td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalPcs"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="845"
                              readOnly
                              disabled={true}
                            />
                          )}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.pcs) || 0), 0)} */}
                      </td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalPlCbm"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="23.23"
                              readOnly
                              disabled={true}
                            />
                          )}
                        />
                      </td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalGrossCbm"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="93.600"
                              readOnly
                              disabled={true}
                            />
                          )}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.grossCbm) || 0), 0).toFixed(2)} */}
                      </td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalNetCbm"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="93.600"
                              readOnly
                              disabled={true}
                              // style={{ border: "1px solid red" }}
                            />
                          )}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.netCbm) || 0), 0).toFixed(2)} */}
                      </td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalAvgRate"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="845"
                              readOnly
                              disabled={true}
                            />
                          )}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.avgRate) || 0), 0).toFixed(2)} */}
                      </td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalAmount"
                          control={control}
                          render={({ field }) => {
                            <input
                              {...field}
                              className="data-entry-input-field"
                              type="number"
                              placeholder="845"
                              step="any"
                              readOnly
                              disabled={true}
                            />;
                          }}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.amt) || 0), 0).toFixed(2)} */}
                      </td>
                      <td></td>
                      <td className="data-entry-label --append-label text-center"></td>
                      <td className="data-entry-label --append-label text-center">
                        <Controller
                          name="totalsellCbm"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              className="data-entry-input-field"
                              placeholder="845"
                              readOnly
                              disabled={true}
                            />
                          )}
                        />
                        {/* {fields.reduce((sum, field) => sum + (parseFloat(field.sellCbm) || 0), 0).toFixed(2)} */}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            {/* Table END */}
            <br />

            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.totalamt}</label>
                <Controller
                  name="totalAmount"
                  control={control}
                  render={({ field }) => {
                    const hasValue = watch("totalAmount");
                    return (
                      <input
                        {...field}
                        className="data-entry-input-field"
                        // readOnly
                        readOnly={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> {Strings.roundoff}</label>
                <Controller
                  control={control}
                  name="roundOff"
                  render={({ field }) => {
                    const hasValue = watch("roundOff");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="roundOff"
                        readOnly={hasValue && !isEditable.roundOff}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                        }}
                        onClick={() => handleInputFocus("roundOff")}
                      />
                    );
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label">
                  {" "}
                  {Strings.totalinvoiceamt}
                </label>
                <Controller
                  control={control}
                  name="totalInvoiceAmt"
                  render={({ field }) => {
                    const hasValue = watch("totalInvoiceAmt");
                    return (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        placeholder="0"
                        readOnly={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="row py-2">
              <div className="col-12 col-md-6 col-lg-4 mb-3 d-flex flex-column flex-md-row align-items-md-center gap-2">
                <label className="responsive-label"> BROKARAGE</label>
                <Controller
                  name="brijesh"
                  control={control}
                  render={({ field }) => {
                    const hasValue = watch("brijesh");
                    return (
                      <input
                        {...field}
                        className="data-entry-input-field"
                        readOnly={true}
                        style={{
                          border: hasValue ? "1px solid #000" : "none",
                          background: hasValue
                            ? "light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4))"
                            : "#fff",
                          color: "#000",
                        }}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="dataEntryInputContainer py-2">
              <div className="data-entry-input-block-two">
                <label className="data-entry-label --data-entry-label-two"></label>
                <div className="data-entry-input-two"></div>
              </div>
            </div>
          </>
        )}

        {activeTab === "doc" && (
          <>
            {/* COPYDOC Start */}
            <Controller
              name="copydoc"
              control={control}
              defaultValue={null}
              render={({ field }) => (
                <>
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".pdf"
                    onChange={(e) => {
                      handleFileChange(e);
                      field.onChange(e);
                    }}
                    style={{ display: "none" }}
                    multiple={true}
                  />
                </>
              )}
            />
            <div
              className="dataEntryAddCopyDocument my-4"
              onClick={triggerFileInput}
            >
              <div className="dataEntryAddInnerCopyDocument">
                <h6 className="data-entry-image-head">ADD COPY DOCUMENT</h6>
              </div>
            </div>
            {fileList?.length > 0 &&
              fileList?.map((file, index) => (
                <div
                  key={index}
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span>
                    {file?.name?.trim() ||
                      file?.fileName?.trim() ||
                      `File ${index + 1}`}
                  </span>
                  <Button
                    type="button"
                    onClick={() => removeFile(index)}
                    style={{ marginLeft: "10px" }}
                  >
                    X
                  </Button>
                </div>
              ))}

            {/* COPYDOC End */}

            {/* invoicedocument End  */}
            {filesvalue?.map((val, index) => (
              <FileUploadContainer
                key={index}
                file={files[index]} // Pass uploaded files
                statepdf={val.state !== null ? val?.name : null} // Set initial state
                onFileChange={(event) => handleFileChanges(index, event)}
                onRemove={() => handleFileRemove(index)}
                name={val?.name}
              />
            ))}

            <div style={{ display: "none" }}>
              <div ref={printRef}>
                <ForwardcontractCopy exchangerate={exchangeRate} />
              </div>
              <div ref={statusRef}>
                <StatusWaiverCopy statuswaiver={statuswaiver} />
              </div>
              <div ref={sblcRef}>
                <SBLCCopy statuswaiver={statuswaiver} />
              </div>
              <div ref={formRef}>
                <FormA1Copy statuswaiver={statuswaiver} />
              </div>
            </div>
            {/* <StatusWaiverCopy /> */}
          </>
        )}

        <div className="dataEntrySubmitBlock mt-5">
          {activeTab !== "doc" && (
            <>
              <button
                type="button"
                onClick={goToNextTab}
                className="data-entry-submit-btn"
              >
                Next
              </button>
            </>
          )}
          {activeTab === "doc" && (
            <>
              {" "}
              <button className="data-entry-submit-btn" type="submit">
                {isCreating || isUpdating ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : (
                  <>SUBMIT</>
                )}
              </button>
            </>
          )}
        </div>
      </form>

      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-2">
          <h6 className="popup-content mb-3">
            {state && state?.id
              ? "Form Updated successfully"
              : "Form Added successfully"}
          </h6>
          <button
            className="user-add-button mt-2 mb-2"
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
          >
            OK
          </button>
        </div>
      </PopUpModal>

      <RightSideDrawer
        toggleDrawer={toggleDrawergf}
        isOpen={isOpen}
        drawerContent={containerfileNamesImg[isIndexing]}
        isIndexing={isIndexing}
        setIsActive={setIsActive}
      />
    </>
  );
};

export default NewDataForm;
